import { DatePipe, Location } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { addAppointmentRequest, serviceAppointmentTimeSlotModel, ProviderModel, appointmentReasonModel, appointmentTimeSlotModel, reschedulePatientAppointModel, scheduleAppointmentModel } from 'src/app/models/appointment/appointment';
import { LocationModel } from 'src/app/models/login/login';
import { AppointmentService } from 'src/app/services/appointment.service';
import { RegistorpatientService } from 'src/app/services/registorpatient.service';
import { getPatientDataByURl, PatientPersonalInfo, VerifypatientModule } from 'src/app/models/verifypatient/verifypatient';
import { VerifypatientService } from 'src/app/services/verifypatient.service';
import moment from 'moment';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { GenericUtilityService } from '../../generic/generic-utility.service';

declare var $: any;
@Component({
  selector: 'app-appointmentexiting',
  templateUrl: './appointmentexiting.component.html',
  styleUrls: ['./appointmentexiting.component.css']
})
export class AppointmentexitingComponent implements OnInit {
  patientpersonalinfo: any;
  selectedProvider: any;
  selectedLocation: any;
  selectedReason: any;
  appointmentReasonData: any;
  minDate: any;
  appointmentForm: FormGroup = new FormGroup({});
  currentTimeZoneOffSet: any;
  appointmentSlots: any[] = [];;
  selectedSlot: any;
  appointmentType: any = 'office';
  providerList: any[] = [];
  locationList: any[] = [];
  reasonList: any[] = [];
  selectedDateApp: any;
  isFirstAvailibleButton: boolean = true;
  selectDateInCelender: boolean = true;
  minDateFull: string = "";
  isFirstAvailable: boolean = true;
  searchResultFlag = false;
  appointmentDate: string = "";
  dSeriesFinal: any;
  FirstDateSearch: any;
  firstAvailableIstrue: boolean = false;
  count: any;
  appOBJ: any;
  TimeZone = "";
  selectedMonthName = '';
  zipCode: string = "";
  hardwareError: boolean = false;
  isAgree: boolean = false;
  isWaitlist: boolean = false;
  formattedAppointmentDate: string = '';
  selectedYear: number = new Date().getFullYear();
  selectedMonth: Date = new Date()
  appointmentFirstDate: Date | string = '';
  firstAvailabeSelectedDate = "";
  providerData: ProviderModel[] = [];
  dSeriesFinalFirstAndLast: any;
  dSeriesFinalWitourSerialize: any;
  showMoreFlags: boolean[] = [];
  public groupedSlots: { [key: string]: any[] } = {};
  public groupedSlotsWaitlist: { [key: string]: any[] } = {};
  expandedSlots: { [key: string]: boolean } = {};
  selectedAppointmentTimeSlot: appointmentTimeSlotModel;
  addAppointmentRequest: addAppointmentRequest = new addAppointmentRequest();
  scheduleAppointmentModel: scheduleAppointmentModel[] = [];
  Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
  ShowSlotsScreens: boolean = false
  isSkipPayment: boolean = false;
  selProvider: ProviderModel;
  AppointmentReason = '';
  Appointmentlocation = '';
  appointment_type: any;
  landFromCheckin: any;
  first_Name: any;
  last_Name: any;
  cell_phone: any;
  Practice_code: any;
  date_Of_Birth: any;
  isDirectUrlMode = false;
  isMonthChanged = false;
  appointmentSlotsLoaded: boolean = false;
  provider: any;
  Location: any;
  reason: any;
  appointmenttype: any;
  availableDate: any;
  availableSlot: any;
  selectedTime: any;
  selectedMonthCalander: any;
  selectedYearCalander: any;
  isFirstAvailableChk: any;
  groupedSlotsArray: any[] = [];
  waitlistSlotsArray: any[] = [];
  selectedDayNumbers: number[] = [];
  selectedAllLocation = 'all';
  isWithin3Hours: any;
  phoneLink: any;
  patientLanguage: any;
  increment: any = 0;
  isWithin24Hours: any;
  getPatientInfo: getPatientDataByURl = new getPatientDataByURl();
  VerifypatientModule: VerifypatientModule;
  PatientPersonalInfo: PatientPersonalInfo;
  isLockScreen: boolean = false;
  isdateUnselect = false;
  dayNames: any = [
    { "id": "0", "Day": "Sun" },
    { "id": "1", "Day": "Mon" },
    { "id": "2", "Day": "Tue" },
    { "id": "3", "Day": "Wed" },
    { "id": "4", "Day": "Thu" },
    { "id": "5", "Day": "Fri" },
    { "id": "6", "Day": "Sat" }
  ]
  monthNames: any = [
    { "id": "1", "Month": "January" },
    { "id": "2", "Month": "February" },
    { "id": "3", "Month": "Mar" },
    { "id": "4", "Month": "April" },
    { "id": "5", "Month": "May" },
    { "id": "6", "Month": "June" },
    { "id": "7", "Month": "July" },
    { "id": "8", "Month": "August" },
    { "id": "9", "Month": "September" },
    { "id": "10", "Month": "October" },
    { "id": "11", "Month": "November" },
    { "id": "12", "Month": "December" }
  ];
  isRtl: boolean = false;
  isFromCancel: boolean = false;
  isFromNewPatient: boolean = false;
  patientpersonalinfoCheckin: any;
  showOnlyMorningSlots: boolean = false;
  showOnlyEveningSlots: boolean = false;
  isDrsite: boolean = false;

  constructor(private translateService: TranslateService, private spinner: NgxSpinnerService, private datePipe: DatePipe, private _phrutilService: PhrutillsService, private appoint: AppointmentService, private datepipe: DatePipe, private _registor: RegistorpatientService
    , private _router: Router, private location: Location, private cdr: ChangeDetectorRef, private _route: ActivatedRoute, private _VerifypatientService: VerifypatientService, private updateinfoservice: UpdateinfoService, private _genericService: GenericUtilityService) {

    this.landFromCheckin = localStorage.getItem("landFrom");
    console.log("landFromCheckin in appointmentexiting component", this.landFromCheckin);

    if (this.landFromCheckin == 'drsite') {
      this.isDrsite = true;
    } else {
      this.isDrsite = false;
    }
    if (this.landFromCheckin == 'checkin_cancel') {
      this.isFromCancel = true;
    } else {
      this.isFromCancel = false;
    }
    if (this.landFromCheckin == 'new_patient') {
      this.isFromNewPatient = true;
    }
    if (this.landFromCheckin == 'checkin_reschedule') {
      this.isDirectUrlMode = true;
    }
    else {
      this.isDirectUrlMode = false;
    }

    if (this.landFromCheckin == 'checkin_reschedule' || this.landFromCheckin == 'checkin_cancel') {
      let info = localStorage.getItem('PersonalInfo');
      if (!info) {
        this._router.navigateByUrl("/home?practice_code=''");
        return;
      }
      const checkinDetails = localStorage.getItem('PatientInfoCheckin');
      this.patientpersonalinfoCheckin = this._phrutilService.decrypt(checkinDetails);
    }
    else {
      let info = localStorage.getItem('PatientInfo');
      if (!info) {
        this._router.navigateByUrl("/home?practice_code=''");
        return;
      }
    }
    this.selectedSlot = new serviceAppointmentTimeSlotModel();
    this.minDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');

    this.reset();
  }
  async ngOnInit(): Promise<void> {
    debugger;
    if (this.Practice_code==100)
    this.filterWellVisit('office');
    this.updateMonthDisplay(this.selectedMonth);
    this._route.queryParams.subscribe(async params => {
      console.log('Query Params:', params);
      if (this.landFromCheckin == 'checkin_reschedule') {
        this.provider = params['provider'] != null ? params['provider'] : this.patientpersonalinfoCheckin.providerCode;
        this.Location = params['location'] != null ? params['location'] : this.patientpersonalinfoCheckin.appointmentLocation;
        this.reason = params['reason'] != null ? params['reason'] : this.patientpersonalinfoCheckin.reason_Id;
        this.appointmenttype = params['appointmenttype'] != null ? params['appointmenttype'] : this.patientpersonalinfoCheckin.appointmentType;
      }
      else {
        this.provider = params['provider'];
        this.Location = params['location'];
        this.reason = params['reason'];
        this.appointmenttype = params['appointmenttype'];
      }
      this.selectedTime = params['selectedSlot'];
      this.availableDate = params['availableDate'];
      this.isFirstAvailableChk = params['isFirstAvailable'];
    });
    try {
      this.isDirectUrlMode = !!(this.provider && this.Location && this.reason && this.appointmenttype);
      if (this.isDirectUrlMode) {
        this.ShowSlotsScreens = true;
      }
      if (this.landFromCheckin == 'checkin_reschedule' || this.landFromCheckin == 'checkin_cancel') {
        this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PersonalInfo'));
        this.Practice_code = this.patientpersonalinfo.PRACTICE_CODE;
      }
      else {
        this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
        //console.log('Patient Info:', this.patientpersonalinfo);
        this.Practice_code = this.patientpersonalinfo.practice_Code;
        this.first_Name = this.patientpersonalinfo.first_Name
      }
      this.appointment_type = this.appointmenttype || localStorage.getItem('appointment_type') || '';
      const selectedValuesFromStorage = localStorage.getItem('selectedValues');
      const SelectedValues = selectedValuesFromStorage ? JSON.parse(selectedValuesFromStorage) : {};
      console.log('Stored Selected Values:', SelectedValues);
      // Use query param values if provided, else fallback to stored values
      const providerValue = this.provider || SelectedValues.providerValue || '';
      const locationValue = this.Location || SelectedValues.locationValue || '';
      const reasonValue = this.reason || SelectedValues.reasonValue || '';
      console.log('Initial Values - Provider:', providerValue, 'Location:', locationValue, 'Reason:', reasonValue, 'Type:', this.appointment_type);
      // Load dropdown data BEFORE slot fetching
      this.providerList = await this.getProviders();
      this.locationList = await this.getLocation();
      this.reasonList = await this.getAppointmentReason();
      if (this.provider && this.Location && this.reason && this.appointmenttype) {
        localStorage.setItem('selectedValues', JSON.stringify({
          providerValue,
          locationValue,
          reasonValue
        }));
        localStorage.setItem('appointment_type', this.appointmenttype);
      }

      // Set dropdown values in form
      this.appointmentForm.patchValue({
        provider: providerValue,
        appointmenttype: this.appointment_type,
        location: locationValue,
        reason: reasonValue
      });
      this.setCurrentMonth();
      if (this.availableDate) {
        console.log('Setting appointment dates from availableDate:', this.availableDate);
        this.setAppointmentDates(this.availableDate);
      }
      else {
        this.setAppointmentDates(new Date());
      }
      this.getCurrentTimeZone();
      if (this.provider && this.Location && this.reason && this.appointmenttype) {
        console.log('All parameters present, fetching slots...');
        this.appointmentSlotsLoaded = false;
        //this.isFirstAvailable = this.isFirstAvailableChk === 'true';;
        this.isFirstAvailable = false

        this.appointmentTimeSlotFlag = true;
        await this.getAppointmentTimeSlot();
        this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
          dateObj.isSelected = false;
          return dateObj;
        });
        this.appointmentSlotsLoaded = true;
        this.ShowSlotsScreens = true;
        //console.log('Retuen slots')
      }
      // Set display helpers
      if (providerValue) {
        this.selectedProvider = {
          providerCode: providerValue,
          providerName: this.getProviderName(providerValue)
        };

      }

      if (locationValue) {
        this.selectedLocation = {
          locationCode: locationValue,
          locationName: this.getLocationName(locationValue)
        };
      }

      if (reasonValue) {
        this.selectedReason = {
          reasonId: reasonValue,
          reasonName: this.getReasonName(reasonValue)
        };
       // console.log(this.Practice_code,"Practice_code")
      }

      // Dates
      this.minDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.minDateFull = this.minDate ?? "";
      this.selectedDateApp = this.minDateFull;
      //console.log('Selected Date:', this.selectedDateApp);
      // Set calendar helpers

      // Slot restoration or automatic fetch
      if (this.availableDate) {
        console.log('Restoring selected slot:', this.availableDate, this.selectedTime);
        const availableDateObj = new Date(this.availableDate);
        this.updateMonthDisplay(availableDateObj);
        this.appointmentDate = this.availableDate;
        this.selectedDateApp = this.availableDate;
        this.isFirstAvailable = this.isFirstAvailableChk === 'true';;
        this.selectedSlot = this.selectedTime ? this.selectedTime.replace(/"/g, '').trim() : null;
        this.appointmentSlotsLoaded = false;
        await this.getAppointmentTimeSlot();
        this.updateCarouselDates(this.appointmentDate);
        this.appointmentSlotsLoaded = true;
        this.appointmentDate = this.availableDate;

        if (this.selectedSlot && Array.isArray(this.appointmentSlots)) {
          this.markSelectedSlot(this.selectedSlot);
        }

        this.ShowSlotsScreens = true;
        this.appointmentTimeSlotFlag = true;
      }
      this.expandedSlots = {};

    } catch (error) {
      console.error("Error during ngOnInit:", error);
    }

    if (this.landFromCheckin === 'checkin_reschedule') {
      this._phrutilService.patientlanguage$.subscribe(language => {
        if (language === 'es') {
          this.isRtl = false;
          this._phrutilService.setTitle('Reprogramar una cita');
        } else if (language === 'hi') {
          this.isRtl = false;
          this._phrutilService.setTitle('अपॉइंटमेंट पुनः निर्धारित करें');
        } else if (language === 'ur') {
          this.isRtl = true;
          this._phrutilService.setTitle('اپوائنٹمنٹ دوبارہ شیڈول کریں');
        }
        else if (language === 'gu') {
          this.isRtl = false;
          this._phrutilService.setTitle('એપોઇન્ટમેન્ટ ફરીથી શેડ્યૂલ કરો');
        } else {
          this.isRtl = false;
          this._phrutilService.setTitle('Reschedule Appointment');
        }
      });
    } else {
      this._phrutilService.patientlanguage$.subscribe(language => {
        if (language === 'es') {
          this.isRtl = false;
          this._phrutilService.setTitle('Reservar una cita');
        } else if (language === 'hi') {
          this.isRtl = false;
          this._phrutilService.setTitle('अपॉइंटमेंट बुक करें');
        } else if (language === 'ur') {
          this.isRtl = true;
          this._phrutilService.setTitle('اپوائنٹمنٹ بک کریں');
        } else if (language === 'gu') {
          this.isRtl = false;
          this._phrutilService.setTitle('એપોઇન્ટમેન્ટ બુક કરો');
        } else {
          this.isRtl = false;
          this._phrutilService.setTitle('Book an Appointment');
        }
      });
    }
    this.appointmentForm.valueChanges.subscribe(() => {
    });
   // this.getTokenForDataScience();
  }
  ngAfterViewInit() {
    // care-team/symptoms-checker DS dependency, currently unused - uncomment if those are reactivated
    // this.getTokenForDataScience();
  }
  ObjAction: any = {};
  trackPatientPreference(lf: any) {
    console.log("landed from ", lf);
    this.ObjAction['patientAccount'] = this.getPatientInfo.patientAccount;
    this.ObjAction['practiceCode'] = this.getPatientInfo.practiceCode;
    this.ObjAction['appointmentID'] = this.getPatientInfo.appointment_id;
    this.ObjAction['action'] = lf;
    this.ObjAction['createdBy'] = this.getPatientInfo.firstName + " " + this.getPatientInfo.lastName;
    this.ObjAction['appSource'] = "breezeCheckin";
    console.log("action object ", this.ObjAction);
    this._VerifypatientService.ManageActionItems(this.ObjAction).subscribe((res: any) => {
      console.log(res);
    }, (error: any) => {
      console.log(error);
    })
  }
  onChangeProvider() {
    this.scheduleAppointmentModel = [];
    this.appointmentTimeSlotFlag = true;
    const providerValue = this.appointmentForm.get('provider')?.value;
    if (providerValue) {
      this.selectedProvider = {
        providerCode: providerValue,
        providerName: this.getProviderName(providerValue)
      };
      localStorage.setItem('selectedProvider', JSON.stringify(this.selectedProvider));
    }
    this.getAppointmentTimeSlot();
  }
  async VerifyPractice(practice_code: any): Promise<void> {
    this.spinner.show();
    try {
      const res: any = await this._registor.VerifyPracticeCode(practice_code).toPromise();

      this.spinner.hide();

      if (res.data && res.statusCode == 200) {
        this.patientpersonalinfo = res.data;
        this.patientpersonalinfo.practice_name = res.data.prac_Name;
        this.patientpersonalinfo.practice_code = res.data.practice_Code;
        this.Practice_code = this.patientpersonalinfo.practice_code;
        let data = this._phrutilService.encrypt(this.patientpersonalinfo);
        localStorage.setItem('PatientInfo', data);
        const landfrom = localStorage.getItem("landFrom");
        localStorage.setItem('pracName', this.patientpersonalinfo.practice_name);
        this._phrutilService.setNavpracName(this.patientpersonalinfo.practice_name);

      } else {
        $("#isNotValid_linkexiting").modal("show");
        throw new Error('Invalid practice code');
      }
    } catch (error) {
      this.spinner.hide();
      $("#isNotValid_linkexiting").modal("show");
      throw error;
    }
  }
  markSelectedSlot(selectedTime: string): void {
    if (!selectedTime || !this.appointmentSlots?.length) return;

    // Clean up in case of stray quotes
    selectedTime = selectedTime.replace(/"/g, '').trim();

    for (const group of this.groupedSlotsArray) {
      if (group.date === this.appointmentDate) {
        for (const slot of group.slots) {
          if (slot.availableSlot === selectedTime && slot.availableDate === this.appointmentDate) {
            this.selectedSlot = slot;
            return; // Exit once the slot is found
          }
        }
      }
    }
    console.warn('No matching slot found for the selected time and date.');
  }
  trackBySlot(index: number, slot: any): string {
    return slot.availableSlot + '_' + slot.availableDate;
  }
  convertToDateFormat(dateStr: string): string {
    const [month, day, year] = dateStr.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }
  // async SelectPatientOption(selectedOption: any) {
  //   this.availableDate = localStorage.getItem('selectedSlotavailableDate');
  //   this.availableSlot = localStorage.getItem('selectedSlotavailableSlot');
  //   this.currentTimeZoneOffSet = localStorage.getItem('currentTimeZoneOffSet');
  //   this.appointmentForm.markAllAsTouched();
  //   if (!this.appointmentForm.invalid && this.selectedSlot.availableSlot && this.selectedSlot.availableDate) {
  //     this.patientpersonalinfo.type = selectedOption;
  //     this.patientpersonalinfo.patient_Account
  //     let data = this._phrutilService.encrypt(this.patientpersonalinfo);
  //     localStorage.setItem('PatientInfo', data);
  //     if (selectedOption == 'check-in') {
  //       this._router.navigateByUrl('/securelogin');
  //     }
  //     else if (selectedOption == 'walkin') {
  //       //this.onChangeDate()
  //       localStorage.setItem('rescheduleProvider', JSON.stringify(this.selectedProvider));
  //       if (this.isDirectUrlMode) {
  //         let Obj_reschedulePatientAppointModel = new reschedulePatientAppointModel();
  //         Obj_reschedulePatientAppointModel.appointment_Id = this.patientpersonalinfo.APPOINTMENT_ID
  //         Obj_reschedulePatientAppointModel.provider_Code = this.provider
  //         Obj_reschedulePatientAppointModel.location_Id = this.Location
  //         Obj_reschedulePatientAppointModel.reason_Id = this.reason
  //         Obj_reschedulePatientAppointModel.practice_Code = this.Practice_code;
  //         Obj_reschedulePatientAppointModel.patient_Account = this.patientpersonalinfo.PATIENT_ACCOUNT
  //         Obj_reschedulePatientAppointModel.patTimeZone = this.currentTimeZoneOffSet
  //         Obj_reschedulePatientAppointModel.appointment_Date = this.availableDate
  //         Obj_reschedulePatientAppointModel.time_From = this.availableSlot.replace(/"/g, '').trim();
  //         this.spinner.show();
  //         this.appoint.ReschedulePatientAppointments(Obj_reschedulePatientAppointModel).subscribe((res: any) => {
  //           if (res && res.data.isAppointmentRescheduled.toLowerCase() == "success") {
  //             this.spinner.hide();
  //             let text = "Appointment has been rescheduled successfully";
  //             this.translateService.get('Alerts.appointment_resech_successfull').subscribe((translation: string) => {
  //               text = translation;
  //             });
  //             this._phrutilService.showSuccess(text);
  //             this._router.navigate(['/appoin-mes'])
  //           } else {
  //             this.spinner.hide();
  //             let text = "Service is not available, please try later.";
  //             this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
  //               text = translation;
  //             });
  //             this._phrutilService.showError(text);
  //           }
  //         }, (error: any) => {
  //           console.log(error);
  //           this.spinner.hide();
  //           let text = "Service is not available, please try later.";
  //           $("#linkexpire-model").modal("show");
  //           this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
  //             text = translation;
  //           });
  //           this._phrutilService.showError(text);
  //         })

  //       }
  //       else {
  //         if (this.isFromCancel) {
  //           this.onAddScheduleAppointment();
  //         }
  //         else if (this.isFromNewPatient) {
  //           this.onAddScheduleAppointment();
  //         }
  //         else {
  //           this._router.navigate(['/securelogin'], { queryParams: { 'type': 'appointment', isFirstAvail: this.isFirstAvailable } });
  //         }

  //         //this.router.navigateByUrl('/login?practice_code='+this.patientpersonalinfo.practice_code);
  //       }
  //     }
  //     else if (selectedOption == 'payment') {
  //       this._router.navigate(['/securelogin'], { queryParams: { 'type': 'payment' } });
  //     }

  //   }
  //   else {
  //     if (!this.appointmentForm.invalid && this.availableSlot == null && this.availableDate == null) {
  //       let text = "Please select appointment slot first.";
  //       this.translateService.get('Alerts.select_slot_first').subscribe((translation: string) => {
  //         text = translation;
  //       });
  //       this._phrutilService.showInfo(text);
  //       //this._phrutilService.showInfo("Please select appointment slot first.");
  //     }
  //     return;
  //   }
  // }
  async SelectPatientOption(selectedOption: any) {
    this.availableDate = localStorage.getItem('selectedSlotavailableDate');
    this.availableSlot = localStorage.getItem('selectedSlotavailableSlot');
    this.currentTimeZoneOffSet = localStorage.getItem('currentTimeZoneOffSet');
    this.appointmentForm.markAllAsTouched();
    if (!this.appointmentForm.invalid && this.selectedSlot.availableSlot && this.selectedSlot.availableDate) {
      this.patientpersonalinfo.type = selectedOption;
      this.patientpersonalinfo.patient_Account //= localStorage.getItem('patientAccount');
      let data = this._phrutilService.encrypt(this.patientpersonalinfo);
      localStorage.setItem('PatientInfo', data);
      if (selectedOption == 'check-in') {
        this._router.navigateByUrl('/securelogin');
      }
      else if (selectedOption == 'walkin') {
        //this.onChangeDate()
        localStorage.setItem('rescheduleProvider', JSON.stringify(this.selectedProvider));
        if (this.isDirectUrlMode) {
          let Obj_reschedulePatientAppointModel = new reschedulePatientAppointModel();
          Obj_reschedulePatientAppointModel.appointment_Id = this.patientpersonalinfo.APPOINTMENT_ID
          Obj_reschedulePatientAppointModel.provider_Code = this.provider
          Obj_reschedulePatientAppointModel.location_Id = this.Location
          Obj_reschedulePatientAppointModel.reason_Id = this.reason
          Obj_reschedulePatientAppointModel.practice_Code = this.Practice_code;
          Obj_reschedulePatientAppointModel.patient_Account = this.patientpersonalinfo.PATIENT_ACCOUNT
          Obj_reschedulePatientAppointModel.patTimeZone = this.currentTimeZoneOffSet
          Obj_reschedulePatientAppointModel.appointment_Date = this.availableDate
          Obj_reschedulePatientAppointModel.time_From = this.availableSlot.replace(/"/g, '').trim();
          this.spinner.show();
          this.appoint.ReschedulePatientAppointments(Obj_reschedulePatientAppointModel).subscribe((res: any) => {
            if (res && res.data.isAppointmentRescheduled.toLowerCase() == "success") {
              this.spinner.hide();
              let text = "Appointment has been rescheduled successfully";
              this.translateService.get('Alerts.appointment_resech_successfull').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showSuccess(text);
              this._router.navigate(['/appoin-mes'])
            } else {
              this.spinner.hide();
              let text = "Service is not available, please try later.";
              this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
                text = translation;
              });
              this._phrutilService.showError(text);
            }
          }, (error: any) => {
            console.log(error);
            this.spinner.hide();
            let text = "Service is not available, please try later.";
            $("#linkexpire-model").modal("show");
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
          })

        }
        else {
          if (this.isFromCancel) {
            this.onAddScheduleAppointment();
          }
          else if (this.isFromNewPatient) {
            this.onAddScheduleAppointment();
            // const dobDay = this.loginForm.controls['dobDay'].value;
            // const dobMonth = this.loginForm.controls['dobMonth'].value;
            // const dobYear = this.loginForm.controls['dobyear'].value;
            // this.formattedDate = dobMonth + "/" + dobDay + "/" + dobYear;
            // console.log("formated date ", this.formattedDate);
            // const firstname = this.loginForm.controls['firstname'].value;
            // const lastname = this.loginForm.controls['lastname'].value;
            // //const result = localStorage.getItem('pcode')
            // //const encryptedPracticeCode = this._phrutilService.encrypt(result);
            console.log("new API hit");
            // // this.getPatientData("DKaCtphNcNUv0Zud0xh3hA==", firstname, lastname, formattedDate);
            //this.getPatientData(this.patientpersonalinfo.practice_Code, localStorage.getItem('firstNameNP'), localStorage.getItem('lastNameNP'), localStorage.getItem('dobNP'))
          }
          else {
            if (this.isWaitlist) {
              $("#waitlistModal").modal("hide");
            }
            this._router.navigate(['/securelogin'], { queryParams: { 'type': 'appointment', isFirstAvail: this.isFirstAvailable } });
          }

          //this.router.navigateByUrl('/login?practice_code='+this.patientpersonalinfo.practice_code);
        }
      }
      else if (selectedOption == 'payment') {
        this._router.navigate(['/securelogin'], { queryParams: { 'type': 'payment' } });
      }

    }
    else {
      if (!this.appointmentForm.invalid && this.availableSlot == null && this.availableDate == null) {
        let text = "Please select appointment slot first.";
        this.translateService.get('Alerts.select_slot_first').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("Please select appointment slot first.");
      }
      return;
    }
  }
  onChangeDate() {
    const providerValue = this.appointmentForm.get('provider')?.value;
    if (providerValue) {
      this.selectedProvider = {
        providerCode: providerValue,
        providerName: this.getProviderName(providerValue)
      };
      // console.log(this.selectedProvider,"selected provider in change date");
     // console.log(this.Practice_code, "Practice_code1")
      if (this.Practice_code == '100')
        this.filterSpecialityReason(this.selectedProvider);
    // console.log("selected provider in onchnagedate");
    localStorage.setItem('selectedProvider', JSON.stringify(this.selectedProvider));
    }

    const locationValue = this.appointmentForm.get('location')?.value;
    if (locationValue) {
      this.selectedLocation = {
        locationCode: locationValue,
        locationName: this.getLocationName(locationValue)
      };
      localStorage.setItem('selectedLocation', JSON.stringify(this.selectedLocation));
    }

    //console.log("selectedReason", this.selectedReason);

    const appointmentTypeValue = this.appointmentForm.get('appointmenttype')?.value;
    // if (!appointmentTypeValue || appointmentTypeValue.trim() === '') {
    //   console.warn('Appointment type is not selected. Validation failed.');
    //   this._phrutilService.showInfo('Please select an appointment type before proceeding.');
    //   return; // Stop further execution
    // }
    console.log('Selected Type:', appointmentTypeValue);
    if (providerValue && locationValue && this.reasonValue && appointmentTypeValue !== '' && appointmentTypeValue !== null) {
      console.log('Selected Provider:', providerValue);
      console.log('Selected Location:', locationValue);
      console.log('Selected Reason:', this.reasonValue);
      const SelectedValues = {
        provider: { providerCode: providerValue, providerName: this.getProviderName(providerValue) },
        location: locationValue ? { id: locationValue, name: this.getLocationName(locationValue) } : null,
        reason: this.reasonValue ? { id: this.reasonValue, name: this.getReasonName(this.reasonValue) } : null
      };
      this.provider = providerValue;
      this.Location = locationValue;
      this.reason = this.reasonValue;
      if (this.landFromCheckin == 'checkin_reschedule') {
        this.patientpersonalinfoCheckin.providerCode = providerValue;
        this.patientpersonalinfoCheckin.appointmentLocation = locationValue;
        this.patientpersonalinfoCheckin.reason_Id = this.reasonValue;
        let data = this._phrutilService.encrypt(this.patientpersonalinfoCheckin);
        localStorage.setItem('PatientInfoCheckin', data);
      }
      this.isFirstAvailable = false;
      this._phrutilService.updateDropdownValues(SelectedValues);
      localStorage.setItem('selectedValues', JSON.stringify(SelectedValues));
      this.appointmentSlotsLoaded = false;
      this.getAppointmentTimeSlot();
      this.appointmentSlotsLoaded = true;
    }
    else {
      return;
    }
  }
  reasonValue: any;
  onchangeReason() {
    this.reasonValue = this.appointmentForm.get('reason')?.value;
    //console.log("reasonValue", reasonValue);
    if (this.reasonValue) {
      //  console.log(reasonValue,"onchange date get name");
      this.selectedReason = {
        reasonId: this.reasonValue,
        reasonName: this.getReasonName(this.reasonValue)
      };

      if (this.Practice_code == '100' && this.selectedReason?.reasonName?.toLowerCase() === "Lab Work Only".toLowerCase()) {
        //console.log("Lab Work Only selected");
        this.reasonValue == null;
        this.selectedReason = null;
        this.appointmentForm.get('reason')?.setValue(null);
        $("#noLabWorkModal").modal("show");
        return;
      }
      else {
        localStorage.setItem('selectedReason', JSON.stringify(this.selectedReason));
      }

      if (this.Practice_code == 100) {
        //console.log('practice code',this.Practice_code);
        const providerMatches = this.allReasonsData?.providerSpecialtyReasons
          ?.filter((p: any) =>
            p.reasons?.some((r: any) => r.reasonId === this.selectedReason.reasonId)
          );

        if (providerMatches?.length) {

          const providerCodes = providerMatches.map((p: any) => p.providerCode);

          // filter providers
          this.selectedProvider = this.providerData.filter((p: any) =>
            providerCodes.includes(p.providerCode)
          );
          this.appointmentForm.get('provider')?.setValue(
            this.selectedProvider?.[0]?.providerCode);
         // console.log("speciality provider", this.selectedProvider);
         // console.log("selected provider", this.appointmentForm.get('provider')?.value);

        } 
      }
      localStorage.setItem('selectedReason', JSON.stringify(this.selectedReason));
      localStorage.setItem('selectedProvider', JSON.stringify(this.selectedProvider));
      this.onChangeDate();
    }
  }
  filterWellVisit(type: any) {

   // console.log(type, "type");

    if (!this.allReasons) return;

    if (type === 'telehealth') {

      if (
        this.selectedReason &&
        (
          this.selectedReason.reasonName?.toLowerCase().includes('annual/well') ||
          this.selectedReason.reasonName?.toLowerCase().includes('well') ||
          this.selectedReason.reasonName?.toLowerCase().includes('injection')
        )
      ) {
        this.selectedReason = null;
        this.appointmentForm.get('reason')?.setValue('');
      }

      this.appointmentReasonData = this.allReasons.filter(
        (reason: any) =>
          !reason.reasonName.toLowerCase().includes('annual/well') &&
          !reason.reasonName.toLowerCase().includes('well') &&
          !reason.reasonName.toLowerCase().includes('injection')
      );

    } else {

      // office case → original list se rebuild
      this.appointmentReasonData = this.allReasons.filter(
        (reason: any) =>
          !reason.reasonName.toLowerCase().includes('injection')
      );

    }

  }

  buildappointmentForm() {
    this.appointmentForm = new FormGroup({
      appointmenttype: new FormControl('', Validators.required),
      provider: new FormControl('', Validators.required),
      location: new FormControl('', Validators.required),
      reason: new FormControl('', Validators.required),
    });
  }
  loadDatesForSelectedMonth(month: number, year: number) {

    if (this.isMonthChanged == true) {
      this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
        const newDate = new Date(year, month - 1, +dateObj.date); // use same day number
        const day = newDate.getDay();
        const dayNameData = this.dayNames.find((x: any) => Number(x.id) === day);
        const dayName = dayNameData?.Day || 'Unknown';

        const monthName = this.monthNames.find((m: { id: string; Month: string }) =>
          m.id == (month).toString())?.Month || '';

        return {
          ...dateObj,
          fullDate: `${month}/${dateObj.date}/${year}`,
          day: dayName,
          month: monthName
        };
      });

      // Update the label above the calendar
      this.selectedMonthName = `${this.monthNames.find((m: { id: string; Month: string }) =>
        m.id == (month).toString())?.Month || ''} ${year}`;
      const selectedDates: string[] = this.dSeriesFinal
        .filter((d: any) => d.isSelected)
        .map((d: any) => d.fullDate);
      this.appointmentDate = this.dSeriesFinal[0].fullDate;
      this.selectedDateApp = this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');
      this.isFirstAvailable = false;
      this.getAppointmentTimeSlot()
    }
    else {
      this.dSeriesFinal = []; // Clear existing dates
      let date = new Date(year, month - 1, 1); // Start at the 1st of the given month
      console.log("selected month and year", date);

      const includeSunday = this.Practice_code === '1011163' || this.Practice_code === '1013886';
      let count = 0; // Counter for weekdays
      while (count < (includeSunday ? 6 : 5)) {
        const day = date.getDay(); // Get the day of the week (0 = Sunday, 6 = Saturday)
        const dayNameData = this.dayNames.find((x: any) => Number(x.id) === day);
        if (dayNameData.Day !== 'Sat' && (dayNameData.Day !== 'Sun' || includeSunday)) { // Skip Saturdays and Sundays
          const dateDigit = date.getDate();
          const monthName = this.monthNames.find((m: { id: string; Month: string }) =>
            m.id == (date.getMonth() + 1).toString())?.Month || '';

          this.dSeriesFinal.push({
            fullDate: `${date.getMonth() + 1}/${dateDigit}/${date.getFullYear()}`, // Ensure correct format
            date: dateDigit,
            day: dayNameData?.Day || 'Unknown',
            month: monthName,
            isDisable: false,
            isSelected: false
          });

          count++;
        }

        date.setDate(date.getDate() + 1); // Move to the next day
      }

      // Reset `isSelected` if `isFirstAvailable` is false
      if (!this.isFirstAvailable) {
        this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
          dateObj.isSelected = false;
          return dateObj;
        });
      }

      this.selectedMonthName = `${this.monthNames.find((m: { id: string; Month: string }) =>
        m.id == (month).toString())?.Month || ''} ${year}`;
    }
  }
  updateCarouselDatesForNewMonth(selectedMonth: number, selectedYear: number): void {
    console.log('Updating carousel dates for new month:', selectedMonth, selectedYear);

    const newDates: any[] = [];
    let count = 0;

    // ✅ Use stored selected date numbers instead of this.dSeriesFinal
    for (const dayNum of this.selectedDayNumbers) {
      const newDate = new Date(selectedYear, selectedMonth - 1, dayNum);
      const dayOfWeek = newDate.getDay();

      // Skip weekends and invalid dates
      if (newDate.getMonth() + 1 === selectedMonth && dayOfWeek !== 0 && dayOfWeek !== 6) {
        const monthName = this.monthNames.find((m: { id: string; Month: string }) =>
          m.id == (newDate.getMonth() + 1).toString())?.Month || '';

        newDates.push({
          fullDate: `${newDate.getMonth() + 1}/${newDate.getDate()}/${newDate.getFullYear()}`,
          date: newDate.getDate(),
          day: this.dayNames.find((x: any) => Number(x.id) === dayOfWeek)?.Day || 'Unknown',
          month: monthName,
          isDisable: false,
          isSelected: true // ✅ Keep selected
        });

        count++;
      }

      if (count >= 5) break;
    }

    this.dSeriesFinal = newDates;
    console.log('Updated dSeriesFinal for new month:', this.dSeriesFinal);
  }
  nextAppointmentDate() {
    // Check if dSeriesFinal is empty
    if (!this.dSeriesFinal || this.dSeriesFinal.length === 0) {
      console.error('dSeriesFinal is empty. Cannot calculate next dates.');
      return;
    }

    //console.log('Current dSeriesFinal:', this.dSeriesFinal);

    // Start from the last date in dSeriesFinal
    let date = new Date(this.dSeriesFinal[this.dSeriesFinal.length - 1].fullDate);
    //console.log('Starting Date for Next Calculation:', date);

    const newDates: { fullDate: string; date: number; day: string; month: string; isDisable: boolean }[] = []; // Array to store the new dates
    let count = 0;
    const includeSunday = this.Practice_code === '1011163' || this.Practice_code === '1013886';

    // Generate 5 next dates
    while (count < (includeSunday ? 6 : 5)) {
      date.setDate(date.getDate() + 1); // Move to the next day
      const day = date.getDay();

      // Skip Sundays
      if (day === 0 && !includeSunday) {
        continue;
      }

      const dateDigit = date.getDate();
      const month = date.getMonth() + 1; // Months are 0-based, so add 1
      const year = date.getFullYear();
      let dayName = this.dayNames.find((x: any) => Number(x.id) === day);
      //const dayName = this.dayNames.find((d: { id: string; Day: string }) => parseInt(d.id) === day)?.Day || 'Unknown';
      const monthName = this.monthNames.find((m: { id: string; Month: string }) => parseInt(m.id) === month)?.Month || 'Unknown';
      if (dayName.Day !== 'Sat' && (dayName.Day !== 'Sun' || includeSunday)) {
        newDates.push({
          fullDate: `${month}/${dateDigit}/${year}`,
          date: dateDigit,
          day: dayName.Day,
          month: monthName,
          isDisable: false,
        });

        count++;
      }
    }

    // Update dSeriesFinal with the new dates
    this.dSeriesFinal = newDates;
    //console.log('Updated dSeriesFinal:', this.dSeriesFinal);
    const validDates = this.dSeriesFinal.map((dateObj: any) =>
      this.datepipe.transform(new Date(dateObj.fullDate), 'MM/dd/yyyy')
    );
    //console.log("valid dates:", validDates);
    //console.log("selected slots:", this.selectedSlot);
    if (this.selectedSlot != null) {
      if (this.selectedSlot.availableDate) {
        const isSelectedSlotsInRange = validDates.includes(this.datepipe.transform(new Date(this.selectedSlot.availableDate), 'MM/dd/yyyy'));
        isSelectedSlotsInRange ? '' : this.selectedSlot = '';
      }
    }
    // const isSelectedSlotsInRange = this.selectedSlot.availableDate ? validDates.includes(this.datepipe.transform(new Date(this.selectedSlot.availableDate), 'MM/dd/yyyy')) : '';
    // isSelectedSlotsInRange ? '' : this.selectedSlot = '';

    // Update the selected date to the first date in the new dSeriesFinal
    this.appointmentDate = this.dSeriesFinal[0].fullDate;
    this.selectedDateApp = this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');
    //console.log('Updated Appointment Date:', this.appointmentDate);

    // Fetch appointment time slots for the updated date
    this.scheduleAppointmentModel = [];
    if (this.appointmentForm.get('provider')?.value.length > 0) {
      this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
        dateObj.isSelected = false;
        return dateObj;
      });
      //console.log('No date selected in the carousel calendar in nextAppointmentDate:', this.dSeriesFinal);
      this.getAppointmentTimeSlot().then(() => {
        this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => ({
          ...dateObj,
          isSelected: false
        }));
        this.cdr.detectChanges(); // Make sure UI reflects this
      });
    }
  }
  previousAppointmentDate() {
    // console.log('Current dSeriesFinal:', this.dSeriesFinal);

    // Start from the first date in dSeriesFinal
    let date = new Date(this.dSeriesFinal[0].fullDate);
    // console.log('Starting Date for Previous Calculation:', date);

    const newDates: { fullDate: string; date: number; day: string; month: string; isDisable: boolean }[] = []; // Array to store the new dates
    let count = 0;
    const includeSunday = this.Practice_code === '1011163' || this.Practice_code === '1013886';

    // Generate 5 previous dates
    while (count < (includeSunday ? 6 : 5)) {
      date.setDate(date.getDate() - 1); // Move to the previous day
      const day = date.getDay();

      // Skip Sundays
      if (day === 0 && !includeSunday) {
        continue;
      }

      const dateDigit = date.getDate();
      const month = date.getMonth() + 1; // Months are 0-based, so add 1
      const year = date.getFullYear();
      let dayName = this.dayNames.find((x: any) => Number(x.id) === day);
      //const dayName = this.dayNames.find((d: { id: string; Day: string }) => parseInt(d.id) === day)?.Day || 'Unknown';
      const monthName = this.monthNames.find((m: { id: string; Month: string }) => parseInt(m.id) === month)?.Month || 'Unknown';

      // Add the new date to the array
      if (dayName.Day !== 'Sat' && (dayName.Day !== 'Sun' || includeSunday)) {
        newDates.push({
          fullDate: `${month}/${dateDigit}/${year}`,
          date: dateDigit,
          day: dayName.Day,
          month: monthName,
          isDisable: false,
        });

        count++;
      }
    }

    // Update dSeriesFinal with the new dates
    this.dSeriesFinal = newDates.reverse(); // Reverse to maintain chronological order
    //console.log('Updated dSeriesFinal:', this.dSeriesFinal);
    const validDates = this.dSeriesFinal.map((dateObj: any) =>
      this.datepipe.transform(new Date(dateObj.fullDate), 'MM/dd/yyyy')
    );
    // console.log("valid dates:", validDates);
    ///console.log("selected slots:", this.selectedSlot.availableDate);
    if (this.selectedSlot != null) {
      if (this.selectedSlot.availableDate) {
        const isSelectedSlotsInRange = validDates.includes(this.datepipe.transform(new Date(this.selectedSlot.availableDate), 'MM/dd/yyyy'));
        isSelectedSlotsInRange ? '' : this.selectedSlot = '';
      }
    }
    // Update the selected date to the first date in the new dSeriesFinal
    this.appointmentDate = this.dSeriesFinal[0].fullDate;
    this.selectedDateApp = this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');
    console.log('Updated Appointment Date:', this.appointmentDate);

    // Fetch appointment time slots for the updated date
    this.scheduleAppointmentModel = [];
    if (this.appointmentForm.get('provider')?.value.length > 0) {
      this.getAppointmentTimeSlot();
    }
  }
  setAppointmentDates(newDate: Date) {
    try {
      console.log('Setting appointment dates for:', newDate);
      let date = new Date(newDate);
      let count = 0;
      const dSeries: any[] = [];
      const preservedDayNumbers = this.selectedDayNumbers || [];
      for (let i = 0; i < 6; i++) {
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const dateDigit = date.getDate();
        const day = date.getDay();
        const dayNameData = this.dayNames.find((x: any) => Number(x.id) === day);
        const dayName = dayNameData?.Day || 'Unknown';
        const monthNameData = this.monthNames.find((x: any) => Number(x.id) === month);
        const monthName = monthNameData?.Month || 'Unknown';
        this.selectedMonthName = `${monthName} ${year}`;

        if ((dayName !== 'Sun' || this.Practice_code === '1011163' || this.Practice_code === '1013886') && count < 6) {
          count++;
          const isSelected = preservedDayNumbers.includes(dateDigit);
          dSeries.push({
            fullDate: `${month}/${dateDigit}/${year}`,
            date: `${dateDigit}`,
            day: dayName,
            month: monthName,
            isDisable: false,
            isSelected
          });
        }
        date.setDate(date.getDate() + 1);
      }
      if (dSeries.length === 0) {
        console.error('dSeriesFinal is empty. Cannot proceed.');
        return;
      }
      this.dSeriesFinal = dSeries;
      //console.log('Updated dSeriesFinal in setAppointmentDates:', this.dSeriesFinal);

      // ✅ Update selectedDayNumbers after new series generation
      this.selectedDayNumbers = this.dSeriesFinal
        .filter((d: any) => d.isSelected)
        .map((d: any) => +d.date);

      console.log('Selected Day Numbers:', this.selectedDayNumbers);

      if (this.dSeriesFinal.length > 0) {
        this.appointmentDate = this.dSeriesFinal[0].fullDate;
      }
      const first = this.dSeriesFinal.at(0);
      const last = this.dSeriesFinal.at(-1);
      this.dSeriesFinalFirstAndLast = [first, last];

      // ✅ Trigger slot fetch for preserved days in the new month
      //this.fetchTimeSlotsForSelectedDays(this.selectedDayNumbers);

    } catch (error) {
      this.OnTrackError(`setAppointmentDates`, error);
    }

    console.log('Updated appointmentDate:', this.appointmentDate);
    // console.log('Updated dSeriesFinalFirstAndLast:', this.dSeriesFinalFirstAndLast);
  }
  updateMonthDisplay(date: Date) {
    let currentMonthIndex = date.getMonth();
    let currentYear = date.getFullYear();

    let lastDayOfMonth = new Date(currentYear, currentMonthIndex + 1, 0).getDate();

    if (date.getDate() === lastDayOfMonth) {
      let newDate = new Date(date.getFullYear(), date.getMonth() + 1, 1); // Move to next month
      this.loadDatesForSelectedMonth(newDate.getMonth() + 1, newDate.getFullYear()); // Load new month
      return; // Stop further execution to prevent duplicate dates
    }

    this.selectedYear = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    this.selectedMonthName = this.monthNames.find((m: { id: string; Month: string }) =>
      m.id == month.toString())?.Month || '';
    this.loadDatesForSelectedMonth(parseInt(month), this.selectedYear);
  }
  getMonthName(monthIndex: number): string {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[monthIndex - 1];
  }
  formatSlotDate(dateString: string): string {
    const date = new Date(dateString);
    return this.datepipe.transform(date, 'EEE, MMM dd') || '';
  }
  chosenMonthHandler(event: Date, datepicker: any) {
    // Close the datepicker
    datepicker.close();
    this.isMonthChanged = true
    // Get the selected month and year
    this.selectedMonthCalander = event.getMonth() + 1; // Months are 0-based, so add 1
    this.selectedYearCalander = event.getFullYear();
    this.appointmentDate = '';
    this.selectedDateApp = null;
    // Load the new dates for the selected month
    this.loadDatesForSelectedMonth(this.selectedMonthCalander, this.selectedYearCalander);
    // Clear the selected slot
    this.selectedSlot = null;
    // Update the UI
    this.cdr.detectChanges();
  }
  reset() {
    this.appointmentForm.reset();
    this.buildappointmentForm();
  }
  get getappointmentForm() {
    return this.appointmentForm.controls;
  }
  formatDateForInput(dateString: string): string {
    if (!dateString) return "";
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const [month, day, year] = parts.map(Number);
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    }
    return new Date(dateString).toISOString().split('T')[0];
  }
  onDatePickerOpen() {
    if (!this.selectedDateApp) {
      this.selectedDateApp = this.minDateFull;
    }

    this.cdr.detectChanges();
  }
  ChangeSkipPayment(event: any) {

    if (event.target.checked) {
      this.isSkipPayment = true;
    }
    else {
      this.isSkipPayment = false;
    }
  }
  onAppointmentTimeSlot(selectedTimeSlot: appointmentTimeSlotModel, selectedScheduleAppointmentModel: scheduleAppointmentModel) {
    this.isSkipPayment = false;
    this.hardwareError = false;
    this.isAgree = false;
    $("#PaymentOption").prop("checked", false);
    this.selectedAppointmentTimeSlot = selectedTimeSlot;
    this.selectedAppointmentTimeSlot.isInsurance = selectedScheduleAppointmentModel.isInsurance;
    this.selectedAppointmentTimeSlot.appointmentCharges = selectedScheduleAppointmentModel.appointmentCharges;
    this.selectedAppointmentTimeSlot.appointmentChargesWithSign = `$ ${selectedScheduleAppointmentModel.appointmentCharges}`;
  }
  setCurrentMonth() {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    this.selectedMonthName = `${this.getMonthName(month)} ${year}`;
  }
  openMonthPicker(picker: MatDatepicker<any>) {
    picker.open();
  }
  formatDateForPicker(dateString: string): string {
    let [month, day, year] = dateString.split('/').map(Number);
    let date = new Date(year, month - 1, day);
    let yyyy = date.getFullYear();
    let mm = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    let dd = String(date.getDate()).padStart(2, '0');       // Ensure two digits
    return `${yyyy}-${mm}-${dd}`;
  }
  updateCarouselDate(selectedDate: string) {
    // Ensure selectedDate is set properly
    if (!selectedDate) return;
    this.selectedDateApp = new Date(selectedDate);
    // Update the form
    this.appointmentForm.patchValue({
      selectedDateApp: selectedDate
    });
    this.cdr.detectChanges(); // Ensure UI updates
  }
  searchAvailable(isFirstAvail: boolean) {
    this.scheduleAppointmentModel = [];
    this.isFirstAvailable = isFirstAvail;
    this.appointmentTimeSlotFlag = true;
    this.searchResultFlag = false;
    this.selectedSlot = null;
    if (isFirstAvail) {
      this.groupedSlotsArray = [];
      this.appointmentSlots = [];
      this.Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
      this.groupedSlots = {};
      // Show only today's date slots
      this.isFirstAvailibleButton = true;
      if (this.isMonthChanged) {
        this.dSeriesFinal = []; // Clear existing dates
        let date = new Date(this.selectedYearCalander, this.selectedMonthCalander - 1, 1); // Start at the 1st of the given month
        let count = 0; // Counter for weekdays
        const includeSunday = this.Practice_code === '1011163' || this.Practice_code === '1013886';

        // Generate the first week of the month (5 weekdays)
        while (count < (includeSunday ? 6 : 5)) {
          const day = date.getDay(); // Get the day of the week (0 = Sunday, 6 = Saturday)

          if (day !== 6 && (day !== 0 || includeSunday)) { // Skip weekends
            const dateDigit = date.getDate();
            const monthName = this.monthNames.find((m: { id: string; Month: string }) =>
              m.id == (date.getMonth() + 1).toString())?.Month || '';

            this.dSeriesFinal.push({
              fullDate: `${date.getMonth() + 1}/${dateDigit}/${date.getFullYear()}`, // Ensure correct format
              date: dateDigit,
              day: this.dayNames.find((x: any) => Number(x.id) === day)?.Day || 'Unknown',
              month: monthName,
              isDisable: false,
              isSelected: false
            });
            count++;
          }
          date.setDate(date.getDate() + 1);
        }
        this.updateCarouselDates(this.dSeriesFinal[0].fullDate);
        this.appointmentDate = this.dSeriesFinal[0].fullDate;
      }
      else {
        // console.log("first avail date in searchAvailable: ", this.FirstDateSearch);
        // console.log("first avail date in searchAvailable: ", this.appointmentDate);
        this.appointmentDate = this.selectedDateApp
      }
      this.getAppointmentTimeSlot().then(() => {
        this.updateCarouselDates(this.appointmentDate);
      });
    }
    else if (!isFirstAvail) {
      console.log("uncheck first avail");
      const validDates = this.dSeriesFinal.map((dateObj: any) =>
        this.datepipe.transform(new Date(dateObj.fullDate), 'MM/dd/yyyy')
      );
      console.log("valid dates: ", validDates);
      // console.log("first dates: ", this.FirstDateSearch);
      // const filteredSlots = this.FirstDateSearch ? validDates.includes(this.datepipe.transform(new Date(this.FirstDateSearch), 'MM/dd/yyyy')) : '';
      // console.log("filtered slots: ", filteredSlots);
      // if (this.FirstDateSearch && filteredSlots) {
      //   this.isFirstAvailibleButton = false;
      //   this.appointmentDate = this.FirstDateSearch
      //   this.isFirstAvailable = false;
      //   this.firstAvailableIstrue = false;
      //   this.scheduleAppointmentModel = [];
      //   // this.dSeriesFinal = this.dSeriesFinal.map((item: any) => ({
      //   //   ...item,
      //   //   isSelected: item.fullDate === this.FirstDateSearch
      //   // }));
      //   this.spinner.show('timeslots');
      //   const Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
      //   Obj_AppointmentTimeSlotModel.providerCode = this.appointmentForm.get('provider')?.value;
      //   Obj_AppointmentTimeSlotModel.locationCode = this.appointmentForm.get('location')?.value;
      //   Obj_AppointmentTimeSlotModel.reasonID = this.appointmentForm.get('reason')?.value;
      //   Obj_AppointmentTimeSlotModel.practiceCode = this.Practice_code;
      //   Obj_AppointmentTimeSlotModel.patientAccount = localStorage.getItem('patientAccount');
      //   Obj_AppointmentTimeSlotModel.patientTimeZone = this.currentTimeZoneOffSet;
      //   Obj_AppointmentTimeSlotModel.isFirstAvailable = this.isFirstAvailable;
      //   Obj_AppointmentTimeSlotModel.date = this.appointmentDate; // Set the selected date
      //   this.SearchFirstAvailableSlot(Obj_AppointmentTimeSlotModel).then((result) => {
      //     if (result) {
      //       console.log('Slot fetched successfully for the selected date.');
      //     } else {
      //       console.warn('No slot available for the selected date.');
      //     }
      //   });
      //   this.spinner.hide('timeslots');
      // }
      //else {
      // Show all appointments for the week but no date should be selected
      this.isFirstAvailibleButton = false;
      this.appointmentDate = '';
      this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
        dateObj.isSelected = false;
        return dateObj;
      });
      //console.log('No date selected in the carousel calendar in searchAvailable:', this.dSeriesFinal);
      this.getAppointmentTimeSlot().then(() => {
        this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => ({
          ...dateObj,
          isSelected: false
        }));
        this.cdr.detectChanges(); // Make sure UI reflects this
      });
    }
    this.cdr.detectChanges(); // Ensure the UI updates
    //}
    /*
    else if (this.FirstDateSearch) {
      this.isFirstAvailibleButton = false;
      this.appointmentDate = this.FirstDateSearch
      this.isFirstAvailable = false;
      this.firstAvailableIstrue = false;
      this.scheduleAppointmentModel = [];
      this.dSeriesFinal = this.dSeriesFinal.map((item: any) => ({
        ...item,
        isSelected: item.fullDate === this.FirstDateSearch
      }));
      this.spinner.show('timeslots');
      const Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
      Obj_AppointmentTimeSlotModel.providerCode = this.appointmentForm.get('provider')?.value;
      Obj_AppointmentTimeSlotModel.locationCode = this.appointmentForm.get('location')?.value;
      Obj_AppointmentTimeSlotModel.reasonID = this.appointmentForm.get('reason')?.value;
      Obj_AppointmentTimeSlotModel.practiceCode = this.Practice_code;
      Obj_AppointmentTimeSlotModel.patientAccount = localStorage.getItem('patientAccount');
      Obj_AppointmentTimeSlotModel.patientTimeZone = this.currentTimeZoneOffSet;
      Obj_AppointmentTimeSlotModel.isFirstAvailable = this.isFirstAvailable;
      Obj_AppointmentTimeSlotModel.date = this.appointmentDate; // Set the selected date
      this.SearchFirstAvailableSlot(Obj_AppointmentTimeSlotModel).then((result) => {
        if (result) {
          console.log('Slot fetched successfully for the selected date.');
        } else {
          console.warn('No slot available for the selected date.');
        }
      });
      this.spinner.hide('timeslots');
    }
    else {
      // Show all appointments for the week but no date should be selected
      this.isFirstAvailibleButton = false;
      this.appointmentDate = '';
      this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
        dateObj.isSelected = false;
        return dateObj;
      });
      console.log('No date selected in the carousel calendar:', this.dSeriesFinal);
      this.getAppointmentTimeSlot().then(() => {
        this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => ({
          ...dateObj,
          isSelected: false
        }));
        this.cdr.detectChanges(); // Make sure UI reflects this
      });
    }
    this.cdr.detectChanges(); // Ensure the UI updates
    */
  }
  onAppointmentDate(selectedDate: any) {
    //this.FirstDateSearch = selectedDate.fullDate;
    if (this.appointmentForm.get('provider')?.value.length == 0) {
      return;
    }
    if (this.appointmentDate == selectedDate.fullDate) {
      //console.log('Selected date is already active.');
      //console.log('appointmentDate:', this.appointmentDate);
      //console.log('selectedDate.fullDate:', selectedDate.fullDate);
      if (selectedDate.fullDate == this.dSeriesFinal[0].fullDate) {
        //console.log('First date in carousel selected/unselected.');
        //console.log('dSeriesFinal[0].fullDate:', this.dSeriesFinal[0].fullDate);
        //console.log('Selected date is already active2.');
        if (this.dSeriesFinal[0].isSelected) {
          //console.log('Unselecting the first date in the carousel calendar.');
          // Reset the selection
          this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
            dateObj.isSelected = false;
            return dateObj;
          });

          // Clear the selected date and slot
          this.appointmentDate = '';
          this.selectedDateApp = null;
          this.selectedSlot = null;
          this.appointmentDate = selectedDate.fullDate;
          this.selectedDateApp = selectedDate.fullDate;
          // Fetch all records
          this.getAppointmentTimeSlot().then(() => {
            //console.log('Fetched all records after unselecting the first date.');
            this.cdr.detectChanges(); // Ensure the UI reflects the changes
          });

          return; // Exit the method as the unselection logic is complete
        }
        this.appointmentDate = selectedDate.fullDate;
        //this.selectedDateApp = this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');
        this.isFirstAvailable = false;
        this.firstAvailableIstrue = false;
        this.scheduleAppointmentModel = [];
        this.selectedSlot = null;
        this.dSeriesFinal = this.dSeriesFinal.map((item: any) => ({
          ...item,
          isSelected: item.fullDate === selectedDate.fullDate
        }));

        //console.log('Selected Appointment Date:', this.appointmentDate)
        //console.log('selectedDateApp:', this.selectedDateApp)
        this.spinner.show('timeslots');
        const Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
        Obj_AppointmentTimeSlotModel.providerCode = this.appointmentForm.get('provider')?.value;
        Obj_AppointmentTimeSlotModel.locationCode = this.appointmentForm.get('location')?.value;
        Obj_AppointmentTimeSlotModel.reasonID = this.appointmentForm.get('reason')?.value;
        Obj_AppointmentTimeSlotModel.practiceCode = this.Practice_code;
        Obj_AppointmentTimeSlotModel.patientAccount = localStorage.getItem('patientAccount');
        Obj_AppointmentTimeSlotModel.patientTimeZone = this.currentTimeZoneOffSet;
        Obj_AppointmentTimeSlotModel.isFirstAvailable = this.isFirstAvailable;
        Obj_AppointmentTimeSlotModel.date = this.appointmentDate; // Set the selected date
        //console.log('Request Object for SearchFirstAvailableSlot:', Obj_AppointmentTimeSlotModel);
        // Call SearchFirstAvailableSlot to fetch the slot for the selected date
        this.SearchFirstAvailableSlot(Obj_AppointmentTimeSlotModel).then((result) => {
          if (result) {
            // console.log('Slot fetched successfully for the selected date.');
          } else {
            // console.warn('No slot available for the selected date.');
          }
        });
      }
      else {
        this.selectedDateApp = this.dSeriesFinal[0].fullDate;
        this.isFirstAvailibleButton = false;
        this.appointmentDate = '';
        this.selectedSlot = null;
        this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
          dateObj.isSelected = false;
          return dateObj;
        });

        //console.log('No date selected in the carousel calendar:', this.dSeriesFinal);

        this.getAppointmentTimeSlot().then(() => {
          this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => ({
            ...dateObj,
            isSelected: false
          }));
          this.cdr.detectChanges();
        });
        // console.log('Selected date is already active.');
      }
    }
    else {
      //console.log('Selected date is already active else statement.');
      this.appointmentDate = selectedDate.fullDate;
      //this.selectedDateApp = this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');
      this.isFirstAvailable = false;
      this.firstAvailableIstrue = false;
      this.scheduleAppointmentModel = [];
      this.selectedSlot = null;
      this.dSeriesFinal = this.dSeriesFinal.map((item: any) => ({
        ...item,
        isSelected: item.fullDate === selectedDate.fullDate
      }));

      //console.log('Selected Appointment Date:', this.appointmentDate)
      //console.log('selectedDateApp:', this.selectedDateApp)
      this.spinner.show('timeslots');
      const Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
      Obj_AppointmentTimeSlotModel.providerCode = this.appointmentForm.get('provider')?.value;
      Obj_AppointmentTimeSlotModel.locationCode = this.appointmentForm.get('location')?.value;
      Obj_AppointmentTimeSlotModel.reasonID = this.appointmentForm.get('reason')?.value;
      Obj_AppointmentTimeSlotModel.practiceCode = this.Practice_code;
      Obj_AppointmentTimeSlotModel.patientAccount = localStorage.getItem('patientAccount');
      Obj_AppointmentTimeSlotModel.patientTimeZone = this.currentTimeZoneOffSet;
      Obj_AppointmentTimeSlotModel.isFirstAvailable = this.isFirstAvailable;
      Obj_AppointmentTimeSlotModel.date = this.appointmentDate; // Set the selected date
      //console.log('Request Object for SearchFirstAvailableSlot:', Obj_AppointmentTimeSlotModel);
      // Call SearchFirstAvailableSlot to fetch the slot for the selected date
      this.SearchFirstAvailableSlot(Obj_AppointmentTimeSlotModel).then((result) => {
        if (result) {
          console.log('Slot fetched successfully for the selected date.');
        } else {
          console.warn('No slot available for the selected date.');
        }
      });
    }
    this.spinner.hide('timeslots');
  }
  custom_sort(a: any, b: any) {
    return new Date(a.fullDate).getTime() - new Date(b.fullDate).getTime();
  }
  async getProviders(): Promise<ProviderModel[]> {
    this.spinner.show();
    return new Promise((resolve, reject) => {
      this.appoint.GetProviderBreeze(this.Practice_code).subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res.data) {
            this.providerData = res.data.providers as ProviderModel[];
            resolve(this.providerData);
          } else {
            this.providerData = [];
            resolve([]);
          }
        },
        (error: any) => {
          this.spinner.hide();
          this.providerData = [];
          reject(error);
        }
      );
    });
  }
  //async getAppointmentReason(): Promise<appointmentReasonModel[]> {
  //  this.appointmentReasonData = [];
  //  this.spinner.show();

  //  return new Promise((resolve, reject) => {
  //    this.appoint.AppointmentReasonsBreeze(this.Practice_code).subscribe(
  //      (res: any) => {
  //        this.spinner.hide();
  //        if (res.data && res.data.appoitnmentReasonsLists) {
  //          this.appointmentReasonData = res.data.appoitnmentReasonsLists as appointmentReasonModel[];
  //          resolve(this.appointmentReasonData); // ✅ Return the appointment reasons
  //        } else {
  //          this.showServiceError();
  //          resolve([]);
  //        }
  //      },
  //      (error: any) => {
  //        this.spinner.hide();
  //        this.showServiceError();
  //        reject(error);
  //      }
  //    );
  //  });
  //}
  allReasonsData: any;
  filterSpecialityReason(providerCodes?: any) {

    //console.log("selected provider", providerCodes);

    let specialityReasons: any[] = [];

    if (this.allReasonsData?.providerSpecialtyReasons?.length && providerCodes) {

      const codes = [providerCodes.providerCode];

      const providerMatches = this.allReasonsData.providerSpecialtyReasons
        .filter((p: any) => codes.includes(p.providerCode));

      specialityReasons = providerMatches.flatMap((p: any) => p.reasons || []);

     // console.log(specialityReasons, "specialityReasons");
    }

    //console.log(this.selectedReason, "selectedReason");

    if (this.selectedReason) {

      // check if selected reason is a speciality reason in system
      const isSpecialityReason = this.allReasonsData?.providerSpecialtyReasons
        ?.some((p: any) =>
          p.reasons?.some((r: any) => r.reasonId === this.selectedReason.reasonId)
        );

      // agar speciality reason hai aur selected provider usko support nahi karta
      if (
        isSpecialityReason &&
        !specialityReasons.some(
          (r: any) => r.reasonId === this.selectedReason.reasonId
        )
      ) {
        console.log("selected provider does not support this speciality reason");

        this.selectedReason = null;
        this.appointmentForm.get('reason')?.setValue(null);
      }
    }
  }
  allReasons: any;
  async getAppointmentReason(): Promise<appointmentReasonModel[]> {
    this.appointmentReasonData = [];
    this.spinner.show();

    return new Promise((resolve, reject) => {
      this.appoint.AppointmentReasonsBreeze(this.Practice_code).subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res.data) {
            this.allReasonsData = res.data;
            //testing code
           /* 
            this.allReasonsData.providerSpecialtyReasons = [
              {
                providerCode: "100",
                reasons: [
                  {
                    reasonId: "9999990000013",
                    reasonName: "Cardiology Consult",
                    providerCode: "100"
                  }
                ]
              },
              {
                providerCode: "55212287",
                reasons: [
                  {
                    reasonId: "9999990000014",
                    reasonName: "Urologist Consult",
                    providerCode: "55212287"
                  }
                ]
              }
            ];
            */
            //testing code end
            if (this.allReasonsData) {
              if (this.Practice_code == '100') {
                this.allReasonsData.appointmentReasonsLists = this.allReasonsData.appointmentReasonsLists.filter((reason: any) => {
                  const name = reason.reasonName.toLowerCase();
                  return !name.includes('initial');
                });
                this.appointmentReasonData = [
                  ...(this.allReasonsData.appointmentReasonsLists || []),
                  ...(this.allReasonsData.providerSpecialtyReasons?.flatMap((p: any) => p.reasons) || [])
                ] as appointmentReasonModel[];
              } else {
                this.appointmentReasonData = this.allReasonsData.appointmentReasonsLists as appointmentReasonModel[];
              }
              this.allReasons = this.appointmentReasonData || []; // original
              resolve(this.appointmentReasonData);
              if (this.Practice_code==100)
                this.filterWellVisit('office');
            }

          } else {
            console.log("0")
            this.showServiceError();
            resolve([]);
          }
        },
        (error: any) => {
          console.log("00")
          this.spinner.hide();
          this.showServiceError();
          reject(error);
        }
      );
    });
  }
  async getLocation(): Promise<LocationModel[]> {
    this.spinner.show();
    return new Promise((resolve, reject) => {
      this.appoint.GetLocationBreeze(this.Practice_code).subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res.data && res.data.locations.length !== 0) {
            let locationTemp = res.data.locations as LocationModel[];
            let filteredLocations = locationTemp.filter(data => data.locationName !== "");
            this.providerLocation = filteredLocations;
            resolve(this.providerLocation);
          } else {
            let text = "Service is not available, please try later.";
            this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showError(text);
            resolve([]);
          }
        },
        (error: any) => {
          this.spinner.hide();
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          reject(error);
        }
      );
    });
  }
  getProviderName(providerId: string): string {
    const provider = this.providerList.find(p => p.providerCode === providerId);
    if (!provider) {
      return 'Unknown Provider';
    }
    return provider.providerName;
  }
  getLocationName(locationId: string): string {
    const location = this.locationList.find(l => l.locationCode === locationId);
    return location ? location.locationName : '';
  }
  getReasonName(reasonId: string): string {
    const reason = this.reasonList.find(r => r.reasonId === reasonId);
    return reason ? reason.reasonName : '';
  }
  onMonthChange(event: any) {
    this.selectedMonth = event;
    this.updateMonthDisplay(event);
  }
  OnTrackError(functionName: string, error: any) {
    console.log(`Error Occured => ${functionName} (Appointments): ${error}`);
  }
  getObjectValues(obj: any): any[] {
    return Object.values(obj);
  }
  ngOnChanges() {
    // Call this when `groupedSlots` changes
    this.updateGroupedSlotsArray();
  }
  updateGroupedSlotsArray(): void {
    this.groupedSlotsArray = Object.entries(this.groupedSlots).map(([date, slots]) => ({ date, slots }));
    this.cdr.detectChanges();
  }
  waitlistGroupedSlotsArray(): void {
    this.waitlistSlotsArray = Object.entries(this.groupedSlotsWaitlist).map(([date, slots]) => ({ date, slots }));
    this.cdr.detectChanges();
  }
  onWaitListClick(date: string) {
    console.log("onWaitListClick called with date:", date);
    $("#waitlistModal").modal("show");
    this.onWaitList(date)
    $("#waitlistModal").modal("hide");
  }
  async onWaitList(waitlistDate: string) {
    console.log("onWaitList called");
    console.log('Selected Appointment Date:', this.appointmentDate)
    this.Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
    this.spinner.show('timeslots');
    this.firstAvailableIstrue = true;
    this.Obj_AppointmentTimeSlotModel.providerCode = this.appointmentForm.get('provider')?.value;
    this.Obj_AppointmentTimeSlotModel.locationCode = this.appointmentForm.get('location')?.value;
    this.Obj_AppointmentTimeSlotModel.practiceCode = this.Practice_code;
    this.Obj_AppointmentTimeSlotModel.patientAccount = localStorage.getItem('patientAccount');
    this.Obj_AppointmentTimeSlotModel.reasonID = this.appointmentForm.get('reason')?.value;
    this.Obj_AppointmentTimeSlotModel.patientTimeZone = this.currentTimeZoneOffSet;
    this.Obj_AppointmentTimeSlotModel.isFirstAvailable = this.isFirstAvailable;
    this.Obj_AppointmentTimeSlotModel.isTelehealth = this.appointment_type == 'office' ? false : true;
    this.Obj_AppointmentTimeSlotModel.date = waitlistDate
    try {
      console.log("Obj_AppointmentTimeSlotModel: ", this.Obj_AppointmentTimeSlotModel);
      const res: any = await this.appoint.GetTimeSlotsForWaitList(this.Obj_AppointmentTimeSlotModel);
      if (res.statusCode == 200) {
        console.log("getAppointmentTimeSlot response: ");
        console.log("getAppointmentTimeSlot response: ", res);
        // this.dSeriesFinal = this.dSeriesFinal.map((item: any) => ({
        //   ...item,
        //   isSelected: item.fullDate === this.appointmentDate
        // }));

        this.isFirstAvailable = false;
        this.isWaitlist = true;
        localStorage.setItem('isWaitlist', JSON.stringify(this.isWaitlist));
        const slots = res.data.appointmentSlots;
        console.log("slots: ", slots);
        this.groupedSlotsWaitlist = this.groupSlotsByDate(slots);
        console.log("groupedSlots: ", this.groupedSlotsWaitlist);
        this.appointmentSlots = slots;
        this.waitlistGroupedSlotsArray();

        if (this.appOBJ.appointmentSlots.length > 0) {
          console.log("getAppointmentTimeSlot response1: ");
          this.appointmentTimeSlotFlag = true;
        } else {
          console.log("getAppointmentTimeSlot response2: ");
          this.appointmentTimeSlotFlag = false;
        }
      }
      this.spinner.hide('timeslots');
    } catch (error) {
      this.OnTrackError(`getAppointmentTimeSlot`, error);
    }
    this.spinner.hide('timeslots');
  }
  trackByFn(index: number, group: any): string {
    return group.date;  // Use a unique identifier (e.g., date)
  }
  groupSlotsByDate(slots: any[]): { [key: string]: any[] } {
    // Extract and normalize the dates from dSeriesFinal
    const validDates = this.dSeriesFinal.map((dateObj: any) =>
      this.datepipe.transform(new Date(dateObj.fullDate), 'MM/dd/yyyy')
    );
    console.log("valid date: ", validDates);
    const filteredSlots = slots.filter(slot =>
      validDates.includes(this.datepipe.transform(new Date(slot.availableDate), 'MM/dd/yyyy'))
    );
    //console.log("filtered slots: ", filteredSlots);
    if (this.isFirstAvailable) {
      return slots.reduce((acc: { [key: string]: any[] }, slot) => {
        const date = this.datepipe.transform(new Date(slot.availableDate), 'MM/dd/yyyy'); // Normalize the available date
        if (date && !acc[date]) {
          acc[date] = []; // Initialize an empty array for this date
        }
        if (date) {
          acc[date].push(slot); // Push the current slot into the correct date group
        }
        return acc;
      }, {} as { [key: string]: any[] });
    } else {
      return filteredSlots.reduce((acc: { [key: string]: any[] }, slot) => {
        const date = this.datepipe.transform(new Date(slot.availableDate), 'MM/dd/yyyy'); // Normalize the available date
        if (date && !acc[date]) {
          acc[date] = []; // Initialize an empty array for this date
        }
        if (date) {
          acc[date].push(slot); // Push the current slot into the correct date group
        }
        return acc;
      }, {} as { [key: string]: any[] });
    }
  }
  onClickMore(index_: number) {
    try {
      this.expandedSlots[index_] = !this.expandedSlots[index_];
    } catch (error) {
      this.OnTrackError(`onClickMore`, error);
    }
  }
  normalizeDate(dateString: string): string {
    const date = new Date(dateString);
    return this.datepipe.transform(date, 'MM/d/yyyy') || '';
  }
  isSlotSelected(slot: any): boolean {
    //log('isSlotSelected called', slot);
    return (
      this.selectedSlot &&
      this.selectedSlot.availableSlot === slot.availableSlot &&
      this.selectedSlot.availableDate === slot.availableDate
    );
  }
  async getAppointmentTimeSlot() {
    this.appointmentForm.markAllAsTouched();
    if (this.appointmentForm.get('provider')?.value.length > 0 && this.appointmentForm.get('appointmenttype')?.value.length > 0 && this.appointmentForm.get('location')?.value.length > 0
      && this.appointmentForm.get('reason')?.value.length > 0) {
      if (this.currentTimeZoneOffSet.length <= 0) {
        this._phrutilService.showInfo("Please set your TimeZone first", "");
        this.appointmentTimeSlotFlag = false;
        return;
      }
      if (new Date(this.appointmentDate) < new Date(this.datepipe.transform(this.minDateFull, 'MM/dd/yyyy') ?? "")) {
        this._phrutilService.showInfo("Previous date appointments can't be scheduled.", "");
        return;
      }

      this.searchResultFlag = true;
      this.appointmentSlotsLoaded = true
      this.appointmentTimeSlotFlag = true;
      this.scheduleAppointmentModel = [];
      this.Obj_AppointmentTimeSlotModel = new serviceAppointmentTimeSlotModel();
      if (this.isFirstAvailable) {
        console.log("isFirstAvailable: ", this.appointmentDate);
        if (!this.appointmentDate || this.appointmentDate === '') {
          this.appointmentDate = this.datepipe.transform(new Date(), "MM/dd/yyyy") ?? "";
        }
        const transformedDate = this.datepipe.transform(this.appointmentDate, "MM/dd/yyyy");
        console.log("isFirstAvailable: ", transformedDate);
        if (transformedDate) {
          this.setAppointmentDates(new Date(transformedDate));
        }
      }
      if (!this.isFirstAvailable) {
        if (this.selectedDateApp == null || this.selectedDateApp == undefined || this.selectedDateApp == '') {
          this.selectedDateApp = this.minDateFull;
        }
        const transformedDate = this.datepipe.transform(this.selectedDateApp, "MM/dd/yyyy");
        console.log("!isFirstAvailable: ", transformedDate);
        if (transformedDate) {
          this.setAppointmentDates(new Date(transformedDate));
        } else {
        }
      }
      else
        if (!this.isFirstAvailable && this.dSeriesFinal[0].fullDate > this.appointmentDate) {
          let dummYCheck: boolean = true;
          for (let i = 0; i < 5; i++) {
            if (this.appointmentDate === this.dSeriesFinal[i]) {
              dummYCheck = false;
            }
          }
          if (dummYCheck) {
            this.setAppointmentDates(new Date(this.appointmentDate));
          }
        }
      const selectedValues = {
        providerValue: this.appointmentForm.value.provider,
        locationValue: this.appointmentForm.value.location,
        reasonValue: this.appointmentForm.value.reason
      };
      localStorage.setItem('selectedValues', JSON.stringify(selectedValues));
      this.count = 0;
      this.spinner.show('timeslots');
      this.firstAvailableIstrue = false;
      this.Obj_AppointmentTimeSlotModel.providerCode = this.appointmentForm.get('provider')?.value;
      this.Obj_AppointmentTimeSlotModel.locationCode = this.appointmentForm.get('location')?.value;
      this.Obj_AppointmentTimeSlotModel.practiceCode = this.Practice_code;
      this.Obj_AppointmentTimeSlotModel.patientAccount = localStorage.getItem('patientAccount');
      this.Obj_AppointmentTimeSlotModel.reasonID = this.appointmentForm.get('reason')?.value;
      this.Obj_AppointmentTimeSlotModel.patientTimeZone = this.currentTimeZoneOffSet;
      this.Obj_AppointmentTimeSlotModel.isFirstAvailable = this.isFirstAvailable;
      this.Obj_AppointmentTimeSlotModel.isTelehealth = this.appointment_type == 'office' ? false : true;

      if (this.isFirstAvailable) {
        const currentDate = new Date(); // Current date
        currentDate.setDate(currentDate.getDate() + 1); // Add 1 day
        const formattedDate = this.datePipe.transform(currentDate, 'MM/dd/yyyy');
        this.Obj_AppointmentTimeSlotModel.date = formattedDate;
        // this.Obj_AppointmentTimeSlotModel.date = this.appointmentDate
        let check = await this.SearchFirstAvailableSlot(this.Obj_AppointmentTimeSlotModel);
      }
      else {
        //this.appointmentDate = '04/22/2024';
        this.Obj_AppointmentTimeSlotModel.startDate = this.appointmentDate;
        const [month, day, year] = this.appointmentDate.split('/').map(Number);
        let currentDate = new Date(year, month - 1, day);
        // Start from the next day
        currentDate.setDate(currentDate.getDate() + 1);
        let weekdaysAdded = 0;
        const includeSunday = this.Practice_code === '1011163' || this.Practice_code === '1013886';
        const targetWeekdays = includeSunday ? 6 : 5;
        while (weekdaysAdded < targetWeekdays) {
          const dayOfWeek = currentDate.getDay(); // 0 = Sunday, 6 = Saturday
          if (dayOfWeek !== 6 && (dayOfWeek !== 0 || includeSunday)) {
            weekdaysAdded++;
          }
          if (weekdaysAdded < targetWeekdays) {
            currentDate.setDate(currentDate.getDate() + 1);
          }
        }
        const formattedEndDate = this.datepipe.transform(currentDate, 'MM/dd/yyyy');
        this.Obj_AppointmentTimeSlotModel.endDate = formattedEndDate;
        this.Obj_AppointmentTimeSlotModel.date = this.appointmentDate;
        try {
          const res: any = await this.appoint.getAppointmentTimeSlotsDateRangeBreeze(this.Obj_AppointmentTimeSlotModel);
          if (res.statusCode == 200) {
            console.log("getAppointmentTimeSlot response: ");
            this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
              dateObj.isSelected = false;
              return dateObj;
            });
            this.isFirstAvailable = false;
            const slots = res.data.appointmentSlots;
            this.groupedSlots = this.groupSlotsByDate(slots);
            this.appointmentSlots = slots;
            this.updateGroupedSlotsArray();
            this.appOBJ = new scheduleAppointmentModel();
            this.appOBJ.provider = this.selectedProvider;
            this.appOBJ.location = this.selectedLocation;
            this.appOBJ.reason = this.selectedReason
            this.ShowSlotsScreens = true
            this.appOBJ.appointmentSlots = res.data.appointmentSlots as appointmentTimeSlotModel[];
            this.scheduleAppointmentModel[this.count] = this.appOBJ;
            this.scheduleAppointmentModel[this.count].isInsurance = res.data.isInsurance;
            this.scheduleAppointmentModel[this.count].appointmentCharges = res.data.appointmentCharges;
            this.count++;
            if (this.appOBJ.appointmentSlots.length > 0) {

              console.log("getAppointmentTimeSlot response1: ");
              this.appointmentTimeSlotFlag = true;
            } else {
              console.log("getAppointmentTimeSlot response2: ");
              this.appointmentTimeSlotFlag = false;
            }
          }
        } catch (error) {
          if (this.scheduleAppointmentModel.length > 0) {
            console.log("getAppointmentTimeSlot response3: ");
            this.appointmentTimeSlotFlag = true;
          } else {
            console.log("getAppointmentTimeSlot response4: ");
            this.appointmentTimeSlotFlag = false;
          }
          this.spinner.hide('timeslots');
        }
      }
      this.spinner.hide('timeslots');
    }
  }
  async SearchFirstAvailableSlot(Obj_AppointmentTimeSlotModel: any) {
    try {
      const res: any = await this.appoint.getAppointmentTimeSlotsBreeze(Obj_AppointmentTimeSlotModel);
      if (this.firstAvailableIstrue) {
        return;
      }

      if (res.data.appointmentSlots && res.data.appointmentSlots.length > 0) {

        this.ShowSlotsScreens = true
        this.appointmentTimeSlotFlag = true;
        this.appointmentSlots = res.data.appointmentSlots;

        if (this.isFirstAvailable && this.appointmentSlots.length > 0) {
          let normalizedDate = this.normalizeDate(this.appointmentSlots[0].availableDate);
          this.appointmentDate = normalizedDate;
          //this.selectedDateApp = this.datepipe.transform(this.appointmentDate, 'yyyy-MM-dd');
          this.updateCarouselDates(this.appointmentDate);
        }
        this.groupedSlots = this.groupSlotsByDate(this.appointmentSlots);
        this.updateGroupedSlotsArray();
        this.appOBJ = new scheduleAppointmentModel();
        this.appOBJ.provider = this.selectedProvider;
        this.appOBJ.location = this.selectedLocation;
        this.appOBJ.reason = this.selectedReason

        this.appOBJ.appointmentSlots = res.data.appointmentSlots as appointmentTimeSlotModel[];
        this.scheduleAppointmentModel[this.count] = { ...this.appOBJ };
        this.scheduleAppointmentModel[this.count].isInsurance = res.data.isInsurance;
        this.scheduleAppointmentModel[this.count].appointmentCharges = res.data.appointmentCharges;

        this.count++;
        this.firstAvailableIstrue = true;
        if (this.scheduleAppointmentModel[this.count - 1].appointmentSlots?.length > 0) {
          this.scheduleAppointmentModel = this.scheduleAppointmentModel.sort((a: any, b: any) =>
            new Date(a.appointmentSlots[0].availableDate + ' ' + a.appointmentSlots[0].availableSlot).valueOf() -
            new Date(b.appointmentSlots[0].availableDate + ' ' + b.appointmentSlots[0].availableSlot).valueOf()
          );
        }
        return true;
      } else {
        this.appointmentTimeSlotFlag = this.scheduleAppointmentModel.length > 0;
        this.firstAvailableIstrue = false;
        // let text;
        // this.translateService.get('Appointment.appointmentSlots.no_slots').subscribe((translation: string) => {
        //   text = translation;
        //   this._phrutilService.showWarning(text);
        // });
        return false;
      }
    } catch (error) {
      console.error("Error fetching appointment slots:", error);

      this.appointmentTimeSlotFlag = this.scheduleAppointmentModel.length > 0;
      this.firstAvailableIstrue = false;
      let text;
      this.translateService.get('Appointment.appointmentSlots.no_slots').subscribe((translation: string) => {
        text = translation;
        this._phrutilService.showWarning(text);
      });
      this.spinner.hide('timeslots');
      return false;
      //throw error;
    }
  }
  updateCarouselDates(selectedDate: string) {
    const normalizedSelectedDate = this.datepipe.transform(new Date(selectedDate), 'MM/d/yyyy');
    this.dSeriesFinal = this.dSeriesFinal.map((dateObj: any) => {
      dateObj.isSelected = this.normalizeDate(dateObj.fullDate) === normalizedSelectedDate;
      return dateObj;
    });
    this.cdr.detectChanges(); // Ensure the UI updates
  }
  onSelectSlot(event: any, slot: any) {
    event.preventDefault();
    event.stopPropagation();
    this.selectedSlot = slot;
    Object.keys(this.groupedSlots).forEach(date => {
      this.groupedSlots[date].forEach((s: any) => {
        s.isSelected = s.availableSlot === slot.availableSlot && s.availableDate === slot.availableDate;
      });
    });
    localStorage.setItem('selectedSlotavailableSlot', JSON.stringify(slot.availableSlot));
    localStorage.setItem('selectedSlotavailableDate', slot.availableDate);
    this.selectedMonth = slot.availableDate
  }
  backPage() {
    console.log('Back button clicked');
    console.log('this.isDirectUrlMode:', this.isDirectUrlMode);
    if (this.ShowSlotsScreens == true) {
      if (this.isDirectUrlMode == true) {
        let query = sessionStorage.getItem('AccessLink');
        // localStorage.setItem("backToConsent", "1");
        if (query == null) {
          query = '';
        }
        this._router.navigateByUrl("patient/verifypatient?pa=" + query);
      }
      else {
        this.ShowSlotsScreens = false
        //this.isDirectUrlMode = false

        setTimeout(() => {

          const restoredSelectedValues = localStorage.getItem('selectedValues');
          const selectedValues = restoredSelectedValues ? JSON.parse(restoredSelectedValues) :
            { providerValue: '', locationValue: '', reasonValue: '' };
          const availableDate = localStorage.getItem('selectedSlotavailableDate') || '';
          this.appointmentForm.patchValue({
            provider: selectedValues.providerValue,
            appointmenttype: this.appointment_type,
            location: selectedValues.locationValue,
            reason: selectedValues.reasonValue,
          });
        }, 500);
      }
    }
    else if (this.isDirectUrlMode == false && this.ShowSlotsScreens == false && this.landFromCheckin == 'checkin_cancel') {
      let query = sessionStorage.getItem('AccessLink');
      // localStorage.setItem("backToConsent", "1");
      if (query == null) {
        query = '';
      }
      this._router.navigateByUrl("patient/verifypatient?pa=" + query);
    }
    else {
      if (this.isDrsite)
        this._router.navigateByUrl("/home?practice_code=" + this.Practice_code + "&lf=drsite");
      else
        this._router.navigateByUrl("/home?practice_code=" + this.Practice_code);
    }
  }
  selectAppointmenttype(type: any) {
    if (this.Practice_code==100)
    this.filterWellVisit(type);
    if (type == 'office') {
      this.appointment_type = 'office';
      //this.onChangeDate();
    }
    if (type == 'telehealth') {
      this.appointment_type = 'telehealth';
      //this.onChangeDate();
    }
    localStorage.setItem('appointment_type', this.appointment_type);
  }
  private showServiceError() {
    let text = "Service is not available, please try later.";
    this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
      text = translation;
    });
    this._phrutilService.showError(text);
  }
  appointmentTimeSlotFlag: boolean = false;
  getCurrentTimeZone() {

    let currDate = new Date().toString();
    let getOffsetwithTime = currDate.split('(');
    let offSet = getOffsetwithTime[0].substr(getOffsetwithTime[0].length - 9);
    this.currentTimeZoneOffSet = offSet.trim();
    if (this.currentTimeZoneOffSet.includes('+')) {
      let RemoveAlpht = this.currentTimeZoneOffSet.split('+');
      this.currentTimeZoneOffSet = '+' + RemoveAlpht[1];
    }
    else if (this.currentTimeZoneOffSet.includes('-')) {
      let RemoveAlpht = this.currentTimeZoneOffSet.split('-');
      this.currentTimeZoneOffSet = '-' + RemoveAlpht[1];
    } localStorage.setItem('currentTimeZoneOffSet', this.currentTimeZoneOffSet);
  }
  getPatientData(pracCode: any, first_name: any, last_name: any, dob: any) {
    console.log("getPatientData called with", pracCode, first_name, last_name, dob);
    this.spinner.show();
    this._VerifypatientService.VerifyExistingPatientByDob(pracCode, first_name, last_name, dob).subscribe((res: any) => {
      this.spinner.hide();
      console.log("response in VerifyExistingPatientByDob", res);
      if (res.data) {
        /*if (res.data.status !== 'no appointment found') {*/
        if (res.data.status == 'success') {
          localStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          sessionStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          localStorage.setItem("RefreashTokenwebServices", res.data.accessTokenResponse.refreshToken);
          localStorage.setItem('pictureAddress', res.data.picture_Address);
          console.log("verii " + res.data.accessTokenResponse.accessToken);
          console.log("verii loc GetData" + localStorage.getItem("AuthTokenwebServices"));
          console.log('Response of getPatientData', res.data);
          this.getPatientInfo.emailAddress = res.data.emailAddress ? this._phrutilService.decryptforServices(res.data.emailAddress) : res.data.emailAddress;
          this.getPatientInfo.visitDate = res.data.visitDate;
          localStorage.setItem('visitDate', this.getPatientInfo.visitDate);
          this.getPatientInfo.timE_FROM = res.data.timE_FROM;
          this.getPatientInfo.visitReason = res.data.visitReason;
          this.getPatientInfo.dateOfBirth = res.data.dateOfBirth ? this._phrutilService.decryptforServices(res.data.dateOfBirth) : res.data.dateOfBirth;
          this.getPatientInfo.cellPhone = res.data.cellPhone ? this._phrutilService.decryptforServices(res.data.cellPhone) : res.data.cellPhone;
          this.getPatientInfo.firstName = res.data.firstName ? this._phrutilService.decryptforServices(res.data.firstName) : res.data.firstName;
          this.getPatientInfo.lastName = res.data.lastName ? this._phrutilService.decryptforServices(res.data.lastName) : res.data.lastName;
          this.getPatientInfo.practiceCode = res.data.practiceCode ? this._phrutilService.decryptforServices(res.data.practiceCode) : res.data.practiceCode;
          this.getPatientInfo.todaY_AMMOUNT = res.data.todaY_AMMOUNT;
          this.getPatientInfo.previouS_AMMOUNT = res.data.previouS_AMMOUNT;
          this.getPatientInfo.providerLastName = res.data.providerLastName ? this._phrutilService.decryptforServices(res.data.providerLastName) : res.data.providerLastName;
          this.getPatientInfo.providerFirstName = res.data.providerFirstName ? this._phrutilService.decryptforServices(res.data.providerFirstName) : res.data.providerFirstName;
          this.getPatientInfo.providerCode = res.data.providerCode ? this._phrutilService.decryptforServices(res.data.providerCode) : res.data.providerCode;
          this.getPatientInfo.practiceName = res.data.practiceName ? this._phrutilService.decryptforServices(res.data.practiceName) : res.data.practiceName;
          this.getPatientInfo.patientAccount = res.data.patientAccount ? this._phrutilService.decryptforServices(res.data.patientAccount) : res.data.patientAccount;
          this.getPatientInfo.appointment_id = res.data.appointment_id ? this._phrutilService.decryptforServices(res.data.appointment_id) : res.data.appointment_id;
          this.getPatientInfo.practicePhone = res.data.practicePhone ? this._phrutilService.decryptforServices(res.data.practicePhone) : res.data.practicePhone;
          this.getPatientInfo.picture_Address = res.data.picture_Address ? this._phrutilService.decryptforServices(res.data.picture_Address) : res.data.picture_Address;
          this.getPatientInfo.languages = res.data.languages ? this._phrutilService.decryptforServices(res.data.languages) : res.data.languages;
          this.getPatientInfo.practiceAddress = res.data.practiceAddress ? this._phrutilService.decryptforServices(res.data.practiceAddress) : res.data.practiceAddress;
          this.getPatientInfo.PracticeCity = res.data.practiceCity ? this._phrutilService.decryptforServices(res.data.practiceCity) : res.data.practiceCity;
          this.getPatientInfo.practiceState = res.data.practiceState ? this._phrutilService.decryptforServices(res.data.practiceState) : res.data.practiceState;
          this.getPatientInfo.praticeZip = res.data.praticeZip ? this._phrutilService.decryptforServices(res.data.praticeZip) : res.data.praticeZip;
          this.getPatientInfo.praticeZip = this._phrutilService.maskingZipNum(this.getPatientInfo.praticeZip);
          this.getPatientInfo.reason_Id = res.data.reason_Id ? this._phrutilService.decryptforServices(res.data.reason_Id) : res.data.reason_Id;
          this.getPatientInfo.reasonName = res.data.reasonName ? this._phrutilService.decryptforServices(res.data.reasonName) : res.data.reasonName;
          this.getPatientInfo.appointmentStatusId = res.data.appointmentStatusId ? this._phrutilService.decryptforServices(res.data.appointmentStatusId) : res.data.appointmentStatusId;
          this.getPatientInfo.appointment_End_DateTime = res.data.appointment_End_DateTime ? this._phrutilService.decryptforServices(res.data.appointment_End_DateTime) : res.data.appointment_End_DateTime;
          this.getPatientInfo.appointmentDuration = res.data.appointmentDuration ? this._phrutilService.decryptforServices(res.data.appointmentDuration) : res.data.appointmentDuration;
          this.getPatientInfo.appointmentAddress = res.data.appointmentAddress ? this._phrutilService.decryptforServices(res.data.appointmentAddress) : res.data.appointmentAddress;
          this.getPatientInfo.appointmentState = res.data.appointmentState ? this._phrutilService.decryptforServices(res.data.appointmentState) : res.data.appointmentState;
          this.getPatientInfo.appointmentCity = res.data.appointmentCity ? this._phrutilService.decryptforServices(res.data.appointmentCity) : res.data.appointmentCity;
          this.getPatientInfo.appointmentZip = res.data.appointmentZip ? this._phrutilService.decryptforServices(res.data.appointmentZip) : res.data.appointmentZip;
          this.getPatientInfo.appointmentZip = this._phrutilService.maskingZipNum(this.getPatientInfo.appointmentZip);

          this.getPatientInfo.isBreezePaymentEnabled = res.data.isBreezePaymentEnabled;
          this.getPatientInfo.isPayLaterEnabled = res.data.isPayLaterEnabled;
          let data = this._phrutilService.encrypt(this.getPatientInfo);
          console.log('getPatientInfo', this._phrutilService.decrypt(data));
          localStorage.setItem('PatientInfoCheckin', data);
          localStorage.setItem('PatientInfo', data);
          console.log('PatientInfoCheckin', this._phrutilService.encrypt(localStorage.getItem('PatientInfo')));
          const landfrom = localStorage.getItem("landFrom");
          if (landfrom != undefined && landfrom != null) {
            this.trackPatientPreference(landfrom);
          }
          console.log("ispaylater enabled ", this.getPatientInfo.isPayLaterEnabled);
          console.log("appt status id ", this.getPatientInfo.appointmentStatusId);
          console.log("appt start time ", this.getPatientInfo.timE_FROM);
          console.log("appt end time ", this.getPatientInfo.appointment_End_DateTime);
          console.log("isBreezePaymentEnabled ", this.getPatientInfo.isBreezePaymentEnabled);
          localStorage.setItem("apptEndTime", this.getPatientInfo.appointment_End_DateTime);
          localStorage.setItem("apptStartTime", this.getPatientInfo.visitDate);
          localStorage.setItem("pcode", this.getPatientInfo.practiceCode);
          localStorage.setItem("reason", this.getPatientInfo.reasonName);
          localStorage.setItem("state", this.getPatientInfo.practiceState);
          localStorage.setItem("city", this.getPatientInfo.PracticeCity);
          localStorage.setItem("zip", this.getPatientInfo.praticeZip);
          localStorage.setItem("Pcell", this.getPatientInfo.practicePhone);
          localStorage.setItem("Padder", this.getPatientInfo.practiceAddress);
          localStorage.setItem("prcode", this.getPatientInfo.providerCode);
          localStorage.setItem("apptId", this.getPatientInfo.appointment_id);
          localStorage.setItem("apptstId", this.getPatientInfo.appointmentStatusId);
          localStorage.setItem("ptcode", this.getPatientInfo.patientAccount);
          localStorage.setItem("fname", this.getPatientInfo.firstName);
          localStorage.setItem("lname", this.getPatientInfo.lastName);
          localStorage.setItem("isBreezePaymentEnabled", this.getPatientInfo.isBreezePaymentEnabled);
          localStorage.setItem("isPayLaterEnabled", this.getPatientInfo.isPayLaterEnabled);
          console.log("patient account ", this.getPatientInfo.patientAccount);
          this.patientpersonalinfo.patient_Account = this.getPatientInfo.patientAccount;
          this.isWithin3Hours = this.checkinBeforeThreeHours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
          localStorage.setItem('isWithin3Hours', this.isWithin3Hours);
          console.log("is with in 3 hours " + this.isWithin3Hours)
          this.verifyPatientfromDS(dob)
          if ((this.getPatientInfo.practiceCode == '1011163' || this.getPatientInfo.practiceCode == '100') && this.getPatientInfo.reasonName == 'Initial Visit') {
            // console.log("using zahid function " + this.ConverttoLocalDate(this.getPatientInfo.visitDate));
            this.isWithin24Hours = this.checkIfVisitWithin24Hours(this.getPatientInfo.visitDate, this.getPatientInfo.timE_FROM);
            console.log("is Same date " + this.isWithin24Hours); // Output: true or false
            localStorage.setItem('isWithin24Hours', this.isWithin24Hours);
          }
          console.log('patientpersonalinfo.type', this.patientpersonalinfo.type);
          this._router.navigateByUrl('/pay_type');
          this._phrutilService.setNavbarLastName(this.getPatientInfo.lastName);
          this._phrutilService.setNavpracName(this.getPatientInfo.practiceName);

        }
        else {
          $("#isNotValid_linkexiting").modal("show");
          return;
        }

      }
      else if (res.message.toLowerCase() == 'no record found') {
        $("#isNotValid_linkexiting").modal("show");
        return;
      }
      else if (res.message.toLowerCase() == 'more than one patient exists with same dob.' || res.message.toLowerCase() == 'more than one first name exists.' || res.message.toLowerCase() == 'more than one patient exists with same last name.') {
        return;
      }
      else {
        $("#linkexpire-model").modal("show");
        return;
      }
    }, (error: any) => {
      this.spinner.hide();
      $("#linkexpire-model").modal("show");
      return;
    });
  }
  getTokenForDataScience() {
    try {
      if (localStorage.getItem('AuthToken')) return;
      this._genericService.getTokenForDataScience().subscribe({
        next: (res: any) => {
          try {
            if (res?.RESPONSE?.token) {
              localStorage.setItem('AuthToken', res.RESPONSE.token);
            }
          } catch (err) {
            console.error('Error storing AuthToken:', err);
          }
        },
        error: (err) => {
          console.error('Error fetching token for data science:', err);
        }
      });
    } catch (err) {
      console.error('Error in getTokenForDataScience:', err);
    }
  }
  verifyPatientfromDS(dob: any) {
    console.log("apna dob... " + dob)
    // Ensure VerifypatientModule is initialized
    if (!this.VerifypatientModule) {
      this.VerifypatientModule = {
        DOB: '',
        PRACTICE_CODE: '',
        LAST_NAME: '',
        FIRST_NAME: '',
        APPOINTMENT_ID: ''
      };
    }
    this.spinner.show();
    this.VerifypatientModule.DOB = dob;
    this.VerifypatientModule.PRACTICE_CODE = this.getPatientInfo.practiceCode;
    this.VerifypatientModule.LAST_NAME = this.getPatientInfo.lastName;
    this.VerifypatientModule.FIRST_NAME = this.getPatientInfo.firstName;
    this.VerifypatientModule.APPOINTMENT_ID = this.getPatientInfo.appointment_id;
    console.log("VerifypatientModule..." + this.VerifypatientModule.DOB)
    this._VerifypatientService.VerifyPatient_v1(this.VerifypatientModule).subscribe((res: any) => {
      this.spinner.hide();
      if (res.Data) {

        this.PatientPersonalInfo = res.Data as PatientPersonalInfo;
        this.PatientPersonalInfo.PRACTICE_CODE = this.VerifypatientModule.PRACTICE_CODE;
        this.PatientPersonalInfo.isShowpicture = true;
        this.PatientPersonalInfo.PracticeName = this.getPatientInfo.practiceName;
        this.PatientPersonalInfo.PROVIDER_CODE = this.getPatientInfo.providerCode;
        this._phrutilService.setPlainPictureAddressSafely(this.PatientPersonalInfo.PICTURE_ADDRESS);
        this.PatientPersonalInfo.PICTURE_ADDRESS = '';
        let data = this._phrutilService.encrypt(this.PatientPersonalInfo);

        console.log("verii loc " + localStorage.getItem("AuthTokenwebServices"));
        localStorage.setItem('PersonalInfo', data);
        //localStorage.setItem("AuthToken", res.RESPONSE[0].ACCESS_TOKEN);
        localStorage.setItem('patientAccount', this.PatientPersonalInfo.PATIENT_ACCOUNT)
        localStorage.setItem('userName', this.PatientPersonalInfo.EMAIL_ADDRESS)
        this.updateinfoservice.onIsShowProfilePic();
        this._VerifypatientService.startRefreshTokenTimer();

        // if (this.isLockScreen) {
        //   localStorage.setItem("lockscreen", "true");
        //   this._router.navigateByUrl('/patient/consent-form');
        // }
        // else
        //   this._router.navigateByUrl('/patient/consent-form');
      } else {
        $("#incorrectinfo-model").modal("show");
      }
    }, (error: any) => {
      $("#incorrectinfo-model").modal("show");
      this.spinner.hide();
    }
    )

  }
  ConverttoLocalDate(date: any): string {
    // if (!date) return '';

    if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;

      // date = moment(date).format('MM/DD/Y h:mm:ss');
      date = moment(date).format('MM/DD/YYYY');
      // date = new Date(date);
    }

    return date;
  }
  onlyCharAllow(event: any, type: any) {
    if (event.value.trim()) {
      let validname = event.value.replace(/[^a-zA-Z ]/g, "");
      event.value = validname;
    }
    else {
      event.value = event.value.trim();
      //this.loginForm.controls[type].setValue(event.value);
    }
  }
  checkinBeforeThreeHours(visitDate: any, visitTime: any) {
    try {
      // Combine visitDate and visitTime into a single string
      const visitDateTimeStr = `${visitDate} ${visitTime}`;

      // Parse visit date and time into a Date object without converting to local timezone
      const visitDateTime = this.ConverttoLocalDateForDiff(visitDateTimeStr);
      console.log("3 hour visit date time: " + visitDateTime);

      // Get the current date and time in UTC
      const currentDateTime = this.ConverttoLocalDateForDiff(new Date());
      console.log("3 hour current date time: " + currentDateTime);

      // Calculate the difference in milliseconds
      const diffInMs = visitDateTime.getTime() - currentDateTime.getTime();

      // Convert the difference to hours
      const diffInHours = diffInMs / (1000 * 60 * 60);
      console.log("3 hour difference: " + diffInHours);

      // Check if the difference is within 3 hours
      return diffInHours <= 3 && diffInHours >= 0;
    } catch (error) {
      console.error("An error occurred while calculating the time difference:", error);
      // Return false if an error occurs
      return false;
    }

  }
  checkIfVisitWithin24Hours(visitDate: string, visitTime: string): boolean {

    const visitDateTime = this.ConverttoLocalDate(visitDate);
    console.log("visit date time " + visitDateTime);
    console.log("visit date time " + typeof visitDateTime);


    // const currentDateFormatted = this.getCurrentDateFormatted();
    // console.log("current date with format " + currentDateFormatted)



    const currentDateTime = this.ConverttoLocalDate(new Date());
    console.log("current date time " + currentDateTime);
    console.log("current date time " + typeof currentDateTime);


    // Add one day to today's date
    const nextDay = this.ConverttoLocalDateInDay(new Date());
    nextDay.setDate(nextDay.getDate() + 1);



    const nextDaydate = this.ConverttoLocalDate(nextDay);
    console.log("next day date " + nextDaydate);
    //console.log("current date time " + typeof currentDateTime);

    if ((visitDateTime.trim() === currentDateTime.trim()) || (visitDateTime.trim() === nextDaydate.trim())) {
      return true;
    } else {
      return false;
    }

  }
  ConverttoLocalDateInDay(date: any): Date {
    // if (!date) return '';

    if (date instanceof Date) {
      date = this.hasTimezone(date) ? this.removeZ(date) : date;

      // date = moment(date).format('MM/DD/Y h:mm:ss');
      date = moment(date).format('MM/DD/YYYY');
      date = new Date(date);
    }

    return date;
  }
  ConverttoLocalDateForDiff(date: any): Date {
    // if (!date) return '';

    // if (date instanceof Date) {
    date = this.hasTimezone(date) ? this.removeZ(date) : date;

    date = moment(date).format('MM/DD/Y h:mm:ss');
    //date = moment(date).format('MM/DD/YYYY');
    date = new Date(date);

    // }

    return date;
  }
  private hasTimezone(value: any) {
    if (typeof value !== 'string') return false;
    return (value.includes('T') || value.includes('t'));
  }
  private removeZ(value: any) {
    if (!value) return '';
    return value.replace(/z|Z/, '');
  }
  onAddScheduleAppointment() {
    console.log('onAddScheduleAppointment called', this.patientpersonalinfoCheckin);
    console.log('onAddScheduleAppointment called', this.patientpersonalinfo);
    console.log('this.patientpersonalinfo.patient_Account', this.patientpersonalinfo.patient_Account);
    this.appointmentForm.markAllAsTouched();
    if (!this.appointmentForm.invalid && this.selectedSlot.availableSlot && this.selectedSlot.availableDate) {
      let Obj_addScheduleAppointmentModel = new addAppointmentRequest();
      Obj_addScheduleAppointmentModel.first_Name = this.isFromNewPatient ? this.patientpersonalinfo.first_Name : this.patientpersonalinfoCheckin.firstName;
      Obj_addScheduleAppointmentModel.last_Name = this.isFromNewPatient ? this.patientpersonalinfo.last_Name : this.patientpersonalinfoCheckin.lastName;
      Obj_addScheduleAppointmentModel.dateofBrith = this.isFromNewPatient ? this.patientpersonalinfo.date_Of_Birth : this.patientpersonalinfoCheckin.dateOfBirth;
      Obj_addScheduleAppointmentModel.email = this.isFromNewPatient ? this.patientpersonalinfo.email_Address : (this.patientpersonalinfoCheckin.emailAddress ? this.patientpersonalinfoCheckin.emailAddress : this.patientpersonalinfoCheckin.cellPhone);
      Obj_addScheduleAppointmentModel.phone = this.isFromNewPatient ? this.patientpersonalinfo.cell_phone : this.patientpersonalinfoCheckin.cellPhone;
      Obj_addScheduleAppointmentModel.app_ReasonId = this.appointmentForm.get('reason')?.value;
      Obj_addScheduleAppointmentModel.location_Code = this.appointmentForm.get('location')?.value
      Obj_addScheduleAppointmentModel.provider_Code = this.appointmentForm.get('provider')?.value;
      Obj_addScheduleAppointmentModel.practice_code = this.isFromNewPatient ? this.patientpersonalinfo.practice_Code : this.patientpersonalinfoCheckin.practiceCode;
      Obj_addScheduleAppointmentModel.patient_Account = this.isFromNewPatient ? this.patientpersonalinfo.patient_Account : this.patientpersonalinfoCheckin.patientAccount;
      Obj_addScheduleAppointmentModel.teleMedicine_Session = this.appointment_type == 'office' ? '0' : '1';
      Obj_addScheduleAppointmentModel.app_date = this.selectedSlot.availableDate;
      Obj_addScheduleAppointmentModel.client_IP = sessionStorage.getItem('IP') ? sessionStorage.getItem('IP') : '';
      Obj_addScheduleAppointmentModel.patTimeZone = this.currentTimeZoneOffSet;
      Obj_addScheduleAppointmentModel.time_From = this.selectedSlot.availableSlot;
      Obj_addScheduleAppointmentModel.isConsentForm = '0';
      this.spinner.show();
      this.appoint.addScheduleAppointment(Obj_addScheduleAppointmentModel).subscribe((res: any) => {
        this.spinner.hide();

        if (res.message.toLowerCase() == "success" && res.statusCode == 200) {
          if (res.data.isAppointmentInserted.toLowerCase() == "true") {
            console.log('Appointment added successfully:', res.data);
            let text = this.landFromCheckin === 'checkin_reschedule' || this.landFromCheckin == 'checkin_cancel'
              ? 'Alerts.appointment_resech_successfull'
              : 'Alerts.appointment_successfull';
            this.translateService.get(text).subscribe((translation: string) => {
              text = translation;
            });
            this._phrutilService.showSuccess(text);
            // this._phrutilService.showSuccess(res.data.finalMessage);
            this.patientpersonalinfo.appointmentid = res.data.appointmentId;
            let data = this._phrutilService.encrypt(this.patientpersonalinfo);
            localStorage.setItem('PersonalInfo', data);
            if (this.isFromNewPatient) {
              const dob = this.patientpersonalinfo.date_Of_Birth.split(' ')[0];
              console.log('New patient DOB:', dob);
              this.getPatientData(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.first_Name, this.patientpersonalinfo.last_Name, this.patientpersonalinfo.date_Of_Birth.split(' ')[0]);
              // localStorage.setItem('PatientInfo', data);
              // this._router.navigateByUrl('/pay_type');
            }
            else {
              this._router.navigateByUrl('/appoin-mes');
            }
          } else {
            if (res.data.finalMessage === "You already have an appointment for this day. In case of any issue please contact provider office.") {
              this.translateService.get('Appointment.appointment_already_exist_for_the_day').subscribe((translation: string) => {
                let text = translation;
                this._phrutilService.showInfo(text);
              });

            } else if (res.data.finalMessage === "You can make only one appointment in 14 days. In case of any issue please contact provider office.") {
              this.translateService.get('Appointment.appointment_14_day_check').subscribe((translation: string) => {
                let text = translation;
                this._phrutilService.showInfo(text);
              });
            }
            else {
              this._phrutilService.showInfo(res.data.finalMessage);
            }
            //this._phrutilService.showInfo(res.data.finalMessage);
          }
        } else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        }
      },
        (error: any) => {
          this.spinner.hide(); let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this._phrutilService.showError(text);
          //this._phrutilService.showError("Service is not available, please try later.");
        });
    }
    else {
      if (!this.appointmentForm.invalid && !this.selectedSlot.availableSlot && !this.selectedSlot.availableDate) {
        let text = "Please select appointment slot first.";
        this.translateService.get('Alerts.select_slot_first').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showInfo(text);
        //this._phrutilService.showInfo("Please select appointment slot first.");
      }
      return;
    }
  }
  providerLocation: any;
  toggleMorningSlots() {
    this.showOnlyMorningSlots = !this.showOnlyMorningSlots;
    this.showOnlyEveningSlots = false;
    this.expandedSlots = {};
  }
  isMorningSlot(slot: any): boolean {
    if (!slot.availableSlot) return false;

    const timeStr = slot.availableSlot.trim().toLowerCase();
    const timeParts = timeStr.split(/[: ]/);
    let hour = parseInt(timeParts[0]);
    const period = timeParts[2];

    if (period === 'pm' && hour !== 12) hour += 12;
    if (period === 'am' && hour === 12) hour = 0;

    return hour < 12;
  }
  toggleEveningSlots() {
    this.showOnlyEveningSlots = !this.showOnlyEveningSlots;
    this.showOnlyMorningSlots = false;
    this.expandedSlots = {};
  }
  isEveningSlot(slot: any): boolean {
    if (!slot.availableSlot) return false;

    const timeStr = slot.availableSlot.trim().toLowerCase();
    const timeParts = timeStr.split(/[: ]/);
    let hour = parseInt(timeParts[0]);
    const period = timeParts[2];

    if (period === 'pm' && hour !== 12) hour += 12;
    if (period === 'am' && hour === 12) hour = 0;

    return hour >= 12;
  }
  getFilteredSlots(group: any): any[] {
    if (this.showOnlyMorningSlots) {
      return group.slots.filter((sl: any) => this.isMorningSlot(sl));
    }
    if (this.showOnlyEveningSlots) {
      return group.slots.filter((sl: any) => this.isEveningSlot(sl));
    }
    return group.slots;
  }
}


